import React, { useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  getCandidate,
  updateCandidate,
  addCandidateAttachments,
  deleteAttachment,
  addCandidateEducation,
  deleteCandidateEducation,
  addCandidateExperience,
  deleteCandidateExperience,
  CandidateChangePassword,
  updateCandidateEducation,
  updateCandidateExperience,
  addCandidateSkills,
  updateCandidateSkill,
  deleteCandidateSkill,
  addCandidateLanguage,
  updateCandidateLanguage,
  deleteCandidateLanguage,
  updateCandidateSummary,
  addCandidateReference,
  updateCandidateReference,
  deleteCandidateReference,
  addCandidateHobby,
  updateCandidateHobby,
  deleteCandidateHobby,
} from "../../../redux/actions/admin/CandidateActions";
import { CircularProgress } from "@material-ui/core";
import { Helmet } from "react-helmet";
import siteService from "../../../services/siteService";
import Select from "react-select";
import isMatch from "date-fns/isMatch";
import validator from "validator";
import moment from "moment";
import "moment/locale/fr";
import { categories, types, degrees } from "../../shared/Helper";
import CustomAlert from "../../shared/views/CustomAlert";
import { DropzoneArea } from "material-ui-dropzone";
import localStorageService from "../../../services/localStorageService";
import CustomHtmlEditor from "../../shared/views/CustomHtmlEditor";
import JoditEditor from "jodit-react";

let CandidateListing = (props) => {
  const {
    getCandidate,
    updateCandidate,
    addCandidateAttachments,
    deleteAttachment,
    addCandidateEducation,
    addCandidateExperience,
    deleteCandidateEducation,
    deleteCandidateExperience,
    storeCandidate,
    CandidateChangePassword,
    updateCandidateEducation,
    updateCandidateExperience,
    addCandidateSkills,
    updateCandidateSkill,
    deleteCandidateSkill,
    addCandidateLanguage,
    updateCandidateLanguage,
    deleteCandidateLanguage,
    updateCandidateSummary,
    addCandidateReference,
    updateCandidateReference,
    deleteCandidateReference,
    hobbyList,
    addCandidateHobby,
    deleteCandidateHobby,
    updateCandidateHobby,
  } = props;
  const closeDeleteReferenceModal = React.useRef();
  const closeFileDeleteModal = React.useRef();
  const closeDeleteEducationModal = React.useRef();
  const closeDeleteExperienceModal = React.useRef();
  const closeDeleteSkillModal = React.useRef();
  const closeDeleteLanguageModal = React.useRef();
  const descriptionHtmlEditor = useRef();
  const [isLoading, setIsLoading] = React.useState(true);
  const currentSite = siteService.getCurrentSite();
  const [invalideEmail, setInvalideEmail] = React.useState(false);
  const [invalideDate, setInvalideDate] = React.useState(false);
  const [isEducationUpdating, setIsEducationUpdating] = React.useState(false);
  const [isExperienceUpdating, setIsExperienceUpdating] = React.useState(false);
  const [isSkillUpdating, setIsSkillUpdating] = React.useState(false);
  const [isLanguageUpdating, setIsLanguageUpdating] = React.useState(false);
  const [isUpdating, setIsUpdating] = React.useState(false);
  const [updated, setUpdated] = React.useState(false);
  const [published, setPublished] = React.useState(false);
  const [showForm, setShowForm] = React.useState(false);
  const [showUpdateForm, setShowUpdateForm] = React.useState({});
  
  const [showExperienceForm, setShowExperienceForm] = React.useState(false);
  const [ showUpdateExperienceForm, setShowUpdateExperienceForm, ] = React.useState({});
  const [showSkillForm, setShowSkillForm] = React.useState(false);
  const [showUpdateSkillForm, setShowUpdateSkillForm] = React.useState({});
  const [showLanguageForm, setShowLanguageForm] = React.useState(false);
  const [showUpdateLanguageForm, setShowUpdateLanguageForm] = React.useState({});
  const [isEducationAdding, setIsEducationAdding] = React.useState(false);
  const [isExperienceAdding, setIsExperienceAdding] = React.useState(false);
  const [isSkillAdding, setIsSkillAdding] = React.useState(false);
  const [isLanguageAdding, setIsLanguageAdding] = React.useState(false);
  const [isUploading, setIsUploading] = React.useState(false);
  const [isDeletting, setIsDeletting] = React.useState(false);
  const [isEducationDeletting, setIsEducationDeletting] = React.useState(false);
  const [isExperienceDeletting, setIsExperienceDeletting] = React.useState(
    false
  );
  const [isSkillDeletting, setIsSkillDeletting] = React.useState(false);
  const [isLanguageDeletting, setIsLanguageDeletting] = React.useState(false);
  const [candidateId, setCandidateId] = React.useState("");
  const [candidate, setCandidate] = React.useState(null);
  const [education, setEducation] = React.useState(null);
  const [updateEducation, setUpdateEducation] = React.useState(null);
  const [workExperience, setWorkExperience] = React.useState(null);
  const [attachmentToDelete, setAttachmentToDelete] = React.useState(null);
  const [educationTodelete, setEducationTodelete] = React.useState(null);
  const [updateWorkExperience, setUpdateWorkExperience] = React.useState(null);
  const [experienceTodelete, setExperienceTodelete] = React.useState(null);
  const [skill, setSkill] = React.useState(null);
  const [updateSkill, setUpdateSkill] = React.useState(null);
  const [skillTodelete, setSkillTodelete] = React.useState(null);
  const [language, setLanguage] = React.useState(null);
  const [updateLanguage, setUpdateLanguage] = React.useState(null);
  const [languageTodelete, setLanguageTodelete] = React.useState(null);
  const [selectedFiles, setSelectedFiles] = React.useState([]);
  const closeCandidateChangePasswordtModal = useRef();
  const [showReferenceForm, setShowReferenceForm] = React.useState(false);
  const [addReferenceFailed, setAddReferenceFailed] = React.useState(false);
  const [isReferenceUpdating, setIsReferenceUpdating] = React.useState(false);
  const [isReferenceAdding, setIsReferenceAdding] = React.useState(false);
  const [referenceTodelete, setReferenceTodelete] = React.useState(null);
  const [referenceToUpdate, setReferenceToUpdate] = React.useState(null);
  const [isReferenceDeletting, setIsReferenceDeletting] = React.useState(false);
  const [passwordPending, setPasswordPending] = React.useState(false);
  const [candidateChangePassword, setCandidateChangePassword] = React.useState({
    id: "",
    newPassword: "",
  });
  const [isPermiting, setIsPermiting] = React.useState(false);
  const [selectedCandidate, setSelectedCandidate] = React.useState(null);
  const [newEducation, setNewEducation] = React.useState({
    candidateId: "",
    title: "",
    degree: "",
    startYear: "",
    endYear: "",
    institute: "",
    description: "",
  });
  const [newExperience, setNewExperience] = React.useState({
    candidateId: "",
    title: "",
    companyName: "",
    jobType: "",
    startDate: "",
    endDate: "",
    description: "",
  });
  const [loginData, setLoginData] = React.useState({
    id: "",
    newPassword: "",
  });
  const [newSkill, setNewSkill] = React.useState({
    candidateId: "",
    title: "",
    percentage: "",
  });
  const [newLanguage, setNewLanguage] = React.useState({
    id: "",
    name: "",
    writingLevel: "",
    speakingLevel: "",
  });
  const [isSummaryAdding, setIsSummaryAdding] = React.useState(false);

  const [candidateSummary, setCandidateSummary] = React.useState(null);
  const [newSummary, setNewSummary] = React.useState({
    candidateId: "",
    description: "",
    title: "",
  });
  const [candidateReference, setCandidateReference] = React.useState(null);
  const [candidateHobby, setCandidateHobby] = React.useState(null);
  const [newReference, setNewReference] = React.useState({
    candidateId: "",
    fullName: "",
    title: "",
    email: "",
    phoneNumber1: "",
    phoneNumber2: "",
  });
  const [showHobbyForm, setShowHobbyForm] = React.useState(false);
  const [isHobbyAdding, setIsHobbyAdding] = React.useState(false);
  const [isHobbyUpdating, setIsHobbyUpdating] = React.useState(false);
  const [isHobbyDeletting, setIsHobbyDeletting] = React.useState(false);
  const [hobbyTodelete, setHobbyTodelete] = React.useState(null);
  const [addHobbyFailed, setAddHobbyFailed] = React.useState(false);
  const [error, setError] = React.useState("");
  const closeDeleteHobbyModal = React.useRef();
  const [
    displayingCandidateHobbyList,
    setDisplayCandidateHobbyList,
  ] = React.useState([]);
  const [newHobby, setNewHobby] = React.useState({
    candidateId: "",
    id: "",
    title: "",
  });
  const [hobbyToUpdate, setHobbyToUpdate] = React.useState({});

  useEffect(() => {
    if (hobbyList !== null && displayingCandidateHobbyList.length === 0) {
      setDisplayCandidateHobbyList(hobbyList);
    }
  }, [hobbyList]);

  useEffect(() => {
    let match = props.match;
    if (match !== undefined) {
      let params = match.params;
      if (params !== undefined && params.id !== undefined) {
        setCandidateId(params.id);
      }
    }
  }, [props.match.params.id]);

  useEffect(() => {
    setIsLoading(true);
    if (candidateId != "") {
      getCandidate(candidateId).then((resp) => {
        setCandidate(resp);
        setEducation(resp.educations);
        setWorkExperience(resp.workExperiences);
        setSkill(resp.skills);
        setLanguage(resp.languages);
        setCandidateSummary((prevState) => ({
          ...prevState,
          description: resp.summaryDescription,
          title: resp.summaryTitle,
        }));
        setCandidateReference(resp.references);
        setCandidateHobby(resp.hobbies);

      });
    }
  }, [candidateId]);

  useEffect(() => {
    if (candidate != null) {
      setIsLoading(false);
    }
  }, [candidate]);

  useEffect(() => {
    if (storeCandidate.candidate !== null) {
      setCandidate(storeCandidate.candidate);
      setEducation(storeCandidate.candidate.educations);
      setWorkExperience(storeCandidate.candidate.workExperiences);
      setSkill(storeCandidate.candidate.skills);
      setLanguage(storeCandidate.candidate.languages);
      setCandidateSummary((prevState) => ({
        ...prevState,
        description: storeCandidate.summaryDescription,
        title: storeCandidate.summaryTitle,
      }));
      setCandidateReference(storeCandidate.candidate.references);
      setCandidateHobby(storeCandidate.candidate.hobbies);
    }
  }, [storeCandidate.candidate]);

  useEffect(() => {
    if (selectedFiles.length > 0) {
      handleAddAttachments();
    }
  }, [selectedFiles]);
  useEffect(() => {
    if (candidateSummary !== null) {
      setNewSummary((prevState) => ({
        ...prevState,
        description: candidateSummary.description,
        title: candidateSummary.title,
      }));
    }
  }, [candidateSummary]);
  useEffect(() => {
    descriptionHtmlEditor.current?.focus();
  }, []);

  const generateYearOptions = () => {
    const currentYear = moment().year();
    const years = [];

    for (let i = currentYear; i >= currentYear - 50; i--) {
      years.push({ value: i, label: i });
    }

    return years;
  };

  const toggleForm = () => {
    setShowForm(!showForm);
  };
  const toggleUpdateForm = (education) => {
    setUpdateEducation(education);
    setShowUpdateForm((prevState) => ({
      ...prevState,
      [education.id]: !prevState[education.id],
    }));
  };

  const toggleExperienceForm = () => {
    setShowExperienceForm(!showExperienceForm);
  };

  const toggleUpdateExperienceForm = (experience) => {
    setUpdateWorkExperience(experience);
    setShowUpdateExperienceForm((prevState) => ({
      ...prevState,
      [experience.id]: !prevState[experience.id],
    }));
  };
  const toggleSkillForm = () => {
    setShowSkillForm(!showSkillForm);
  };

  const toggleUpdateSkillForm = (skill) => {
    setUpdateSkill(skill);
    setShowUpdateSkillForm((prevState) => ({
      ...prevState,
      [skill.id]: !prevState[skill.id],
    }));
  };

  const toggleLanguageForm = () => {
    setShowLanguageForm(!showLanguageForm);
  };

  const toggleUpdateLanguageForm = (language) => {
    setUpdateLanguage(language);
    setShowUpdateLanguageForm((prevState) => ({
      ...prevState,
      [language.id]: !prevState[language.id],
    }));
  };

  const handleSubmit = () => {
    setIsUpdating(true);
    let candidat = candidate;
    if (candidat.birthDay == "") {
      candidat.birthDay = null;
    }
    updateCandidate(candidat).then((data) => {
      if (data.success) {
        setUpdated(true);
        setCandidate(data.candidate);
      }
      setIsUpdating(false);
    });
  };

  const handleAddAttachments = () => {
    setIsUploading(true);
    let candidate = localStorageService.getItem("malibaara_auth_candidate");
    addCandidateAttachments(candidate?.id, selectedFiles).then((data) => {
      if (data.success) {
        setCandidate(data.candidate);
      }
      setIsUploading(false);
    });
  };

  const handleDeleteAttachment = (attachmentId) => {
    setIsDeletting(true);
    let candidate = localStorageService.getItem("malibaara_auth_candidate");
    deleteAttachment(candidate?.id, attachmentId).then((data) => {
      if (data.success) {
        setCandidate(data.candidate);
      }
      setAttachmentToDelete("");
      closeFileDeleteModal.current.click();
      setIsDeletting(false);
    });
  };
  const handleCreateEducationSubmit = () => {
    setIsEducationAdding(true);
    let education = newEducation;
    let candidate = localStorageService.getItem("malibaara_auth_candidate");
    education.candidateId = candidate.id;
    addCandidateEducation(education).then((data) => {
      if (data.success === true) {
        setEducation(data.candidate.educations);
        setCandidate(data.candidate);
        clearEducationForm();
      }
      setIsEducationAdding(false);
      setPublished(true);
      setShowForm(false);
      setIsEducationAdding(false);
    });
  };

  const clearEducationForm = () => {
    setNewEducation({
      candidateId: "",
      title: "",
      degree: "",
      startYear: "",
      endYear: "",
      institute: "",
      description: "",
    });
  };

  const handleUpdateEducationSubmit = () => {
    setIsEducationUpdating(true);
    let education = updateEducation;
    education.candidateId = candidateId;
    updateCandidateEducation(education).then((data) => {
      if (data == true) {
        setEducation(data.candidate.educations);
        setCandidate(data.candidate);
      }
      setIsEducationUpdating(false);
      setPublished(true);
      toggleUpdateForm(education);
    });
  };

  const handleDeleteEducationSubmit = () => {
    setIsEducationDeletting(true);
    deleteCandidateEducation(candidateId, educationTodelete.id).then((resp) => {
      if (resp.success == true) {
        setEducation(resp.candidate.educations);
        setCandidate(resp.candidate);
      }
      setEducationTodelete("");
      closeDeleteEducationModal.current.click();
      setIsEducationDeletting(false);
    });
  };
  const handleCreateExperienceSubmit = () => {
    setIsExperienceAdding(true);
    let experience = newExperience;
    let candidate = localStorageService.getItem("malibaara_auth_candidate");
    experience.candidateId = candidate.id;
    addCandidateExperience(experience).then((data) => {
      if (data.success) {
        setWorkExperience(data.candidate.workExperiences);
        setCandidate(data.candidate);
        clearExperienceForm();
      }
      setIsExperienceAdding(false);
      setPublished(true);
      setShowExperienceForm(false);
      setIsExperienceAdding(false);
    });
  };
  const clearExperienceForm = () => {
    setNewExperience({
      candidateId: "",
      title: "",
      companyName: "",
      jobType: "",
      startDate: "",
      endDate: "",
      description: "",
    });
  };
  const handleUpdateExperienceSubmit = () => {
    setIsUpdating(true);
    let experience = updateWorkExperience;
    experience.candidateId = candidateId;
    updateCandidateExperience(experience).then((data) => {
      if (data == true) {
        setWorkExperience(data.candidate.workExperiences);
        setCandidate(data.candidate);
      }
      setIsExperienceUpdating(false);
      setPublished(true);
      toggleUpdateExperienceForm(experience);
    });
  };

  const handleDeleteExperienceSubmit = () => {
    setIsExperienceDeletting(true);
    deleteCandidateExperience(candidateId, experienceTodelete.id).then(
      (resp) => {
        if (resp.success == true) {
          setWorkExperience(resp.candidate.workExperiences);
          setCandidate(resp.candidate);
        }
        setExperienceTodelete("");
        closeDeleteExperienceModal.current.click();
        setIsExperienceDeletting(false);
      }
    );
  };

  let handleChangeCandidatePasswordSubmit = () => {
    setIsPermiting(true);
    setPublished(false);
    let data = { id: selectedCandidate.id, newPassword: loginData.newPassword };
    CandidateChangePassword(data).then((resp) => {
      if (resp) {
        setIsPermiting(false);
        setPublished(true);
        setTimeout(() => {
          setPublished(false);
          closeCandidateChangePasswordtModal.current.click();
        }, 1500);
      }
    });
  };

  let openCandidateChangePasswordModal = (candidate) => {
    setSelectedCandidate(candidate);
    setCandidateChangePassword(true);
  };

  const handleCreateSkillSubmit = () => {
    setIsSkillAdding(true);
    let skill = newSkill;
    let candidate = localStorageService.getItem("malibaara_auth_candidate");
    skill.candidateId = candidate.id;
    addCandidateSkills(skill).then((data) => {
      if (data.success) {
        setSkill(data.candidate.skills);
        setCandidate(data.candidate);
        clearSkillForm();
      }
      setIsSkillAdding(false);
      setPublished(true);
      setShowSkillForm(false);

      setIsSkillAdding(false);
    });
  };
  const clearSkillForm = () => {
    setNewSkill({
      candidateId: "",
      title: "",
      percentage: "",
    });
  };
  const handleUpdateSkillSubmit = () => {
    setIsSkillUpdating(true);
    let skill = updateSkill;
    skill.candidateId = candidateId;
    updateCandidateSkill(skill).then((data) => {
      if (data == true) {
        setSkill(data.candidate.skills);
        setCandidate(data.candidate);
      }
      setIsSkillUpdating(false);
      setPublished(true);
      toggleUpdateSkillForm(skill);
    });
  };

  const handleDeleteSkillSubmit = () => {
    setIsSkillDeletting(true);
    deleteCandidateSkill(candidateId, skillTodelete.id).then((resp) => {
      if (resp.success == true) {
        setSkill(resp.candidate.skills);
        setCandidate(resp.candidate);
      }
      setSkillTodelete("");
      closeDeleteSkillModal.current.click();
      setIsSkillDeletting(false);
    });
  };

  const handleCreateLanguageSubmit = () => {
    setIsLanguageAdding(true);
    let language = newLanguage;
    language.candidateId = candidateId;
    addCandidateLanguage(language).then((data) => {
      if (data.success) {
        setLanguage(data.candidate.languages);
        setCandidate(data.candidate);
        clearLanguageForm();
      }
      setIsLanguageAdding(false);
      setPublished(true);
      setShowLanguageForm(false);
    });
  };
  const clearLanguageForm = () => {
    setNewLanguage({
      candidateId: "",
      name: "",
      writingLevel: "",
      speakingLevel: "",
    });
  };

  const handleUpdateLanguageSubmit = () => {
    setIsLanguageUpdating(true);
    let language = updateLanguage;
    language.candidateId = candidateId;
    updateCandidateLanguage(language).then((data) => {
      if (data == true) {
        setLanguage(data.candidate.languages);
        setCandidate(data.candidate);
      }
      setIsLanguageUpdating(false);
      setPublished(true);
      toggleUpdateLanguageForm(language);
    });
  };

  const handleDeleteLanguageSubmit = () => {
    setIsLanguageDeletting(true);
    deleteCandidateLanguage(candidateId, languageTodelete?.id).then((resp) => {
      if (resp.success === true) {
        setLanguage(resp.candidate.languages);
        setCandidate(resp.candidate);
      }
      setLanguageTodelete("");
      closeDeleteLanguageModal.current.click();
      setIsLanguageDeletting(false);
    });
  };

  const handleCreateSummarySubmit = async () => {
    setIsSummaryAdding(true);
    setError("");
    const candidate = localStorageService.getItem("malibaara_auth_candidate");
    const presentation = { ...newSummary, candidateId: candidate.id };
    try {
      const data = await updateCandidateSummary(presentation);
      if (data.success) {
        setPublished(true);
      }
    } catch (error) {
      setError("Failed to save summary. Please try again.");
    } finally {
      setIsSummaryAdding(false);
    }
  };

  const handleEditorChange = (value) => {
    setNewSummary((prevState) => ({
      ...prevState,
      description: value,
    }));
    localStorageService.setItem("presentation_summary", value);
  };
  const handleSaveButtonClick = () => {
    handleCreateSummarySubmit();
  };

  const config = useMemo(
    () => ({
      readonly: false,
      placeholder: "",
    }),
    []
  );

  const clearReferenceForm = () => {
    setNewReference({
      candidateId: "",
        fullName: "",
        title: "",
        email: "",
        phoneNumber1: "",
        phoneNumber2: "",
    });
  };
  const toggleReferenceForm = () => {
    setShowReferenceForm(!showReferenceForm);
  };

  const toggleUpdateReferenceForm = (reference) => {
    setReferenceToUpdate(reference);
    setShowUpdateForm((prevState) => ({
      ...prevState,
      [reference.id]: !prevState[reference.id],
    }));
  };

  const toggleHobbyForm = () => {
    setShowHobbyForm(!showHobbyForm);
  };

  const toggleUpdateHobbyForm = (hobby) => {
    setHobbyToUpdate(hobby);
    setShowUpdateForm((prevState) => ({
      ...prevState,
      [hobby.id]: !prevState[hobby.id],
    }));
  };

  const handleCreateReferenceSubmit = async () => {
    setIsReferenceAdding(true);
    let reference = newReference;
    let candidate = localStorageService.getItem("malibaara_auth_candidate");
    reference.candidateId = candidate.id;
    try {
      const data = await addCandidateReference(reference);
      if (data.success) {
        setAddReferenceFailed(false);
        setCandidateReference(data.candidate.references);
        setCandidate(data.candidate);
        clearReferenceForm();
        setIsReferenceAdding(false);
        setPublished(true);
      setShowReferenceForm(false);
      }
      setIsReferenceAdding(false);
      setPublished(true);
      setShowReferenceForm(false);
      
    } catch (error) {
      setAddReferenceFailed(true);
    }
  };

  const handleUpdateReferenceSubmit = () => {
    setIsReferenceUpdating(true);
    let reference = referenceToUpdate;
    let candidate = localStorageService.getItem("malibaara_auth_candidate");
    reference.candidateId = candidate.id;
    updateCandidateReference(reference).then((data) => {
      if (data === true) {
        setCandidateReference(data.candidate.references);
        setCandidate(data.candidate);
      }
      setIsReferenceUpdating(false);
      setPublished(true);
      toggleUpdateReferenceForm(reference);
    });
  };

  const handleDeleteReferenceSubmit = () => {
    setIsReferenceDeletting(true);
    let candidate = localStorageService.getItem("malibaara_auth_candidate");
    deleteCandidateReference(candidate?.id, referenceTodelete?.id).then(
      (resp) => {
        if (resp.success === true) {
          setCandidateReference(resp.candidate.references);
          setCandidate(resp.candidate);
        }
        setReferenceTodelete("");
        closeDeleteReferenceModal.current.click();
        setIsReferenceDeletting(false);
      }
    );
  };

  const handleCreateHobbySubmit = async () => {
    setIsHobbyAdding(true);
    let hobby = newHobby;
    let candidate = localStorageService.getItem("malibaara_auth_candidate");
    hobby.candidateId = candidate.id;
    try {
      const data = await addCandidateHobby(hobby);
      if (data.success) {
        setAddHobbyFailed(false);
        setDisplayCandidateHobbyList(data.candidate.hobbies);
        setCandidateHobby(data.candidate.hobbies);
        setCandidate(data.candidate);
        clearHobbyForm();
        
      }
      setIsHobbyAdding(false);
      setPublished(true);
      setShowHobbyForm(false);
      
    } catch (error) {
      setAddHobbyFailed(true);
    }
  };
  const clearHobbyForm = () => {
    setNewHobby({
        candidateId: "",
        id:"",
        title: "",
    });
  };
  const handleUpdateHobbySubmit = () => {
    setIsHobbyUpdating(true);
    let hobby = hobbyToUpdate;
    let candidate = localStorageService.getItem("malibaara_auth_candidate");
    hobby.candidateId = candidate.id;

    updateCandidateHobby(hobby).then((data) => {
      if (data.success) {
        setDisplayCandidateHobbyList(data.candidate.hobbies);
        setCandidate(data.candidate);
      }
      setIsHobbyUpdating(false);
      setPublished(false);
      toggleUpdateForm(hobby);
    });
  };

  const handleDeleteHobbySubmit = () => {
    setIsHobbyDeletting(true);
    let candidate = localStorageService.getItem("malibaara_auth_candidate");
    deleteCandidateHobby(candidate?.id, hobbyTodelete?.id).then(
      (resp) => {
        if (resp.success === true) {
          setCandidateHobby(resp.candidate.hobbies);
          setCandidate(resp.candidate);
        }
        setHobbyTodelete("");
        closeDeleteHobbyModal.current.click();
        setIsHobbyDeletting(false);
      }
    );
  };

  return (
    <>
      <Helmet>
        <title> Administration | Candidats | {currentSite.fullName}</title>
      </Helmet>
      {isLoading ? (
        <>
          <div className="row bg-white pt-4 mt-lg-0">
            <div className="col-lg-12">
              <div className="loading-container bg-white">
                <CircularProgress />
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="row">
            <div className="col-lg-12 mt-4 bg-white pt-0 mt-lg-0">
              <div className="bg-light-2 p-4">
                <div className="row">
                  <div className="col-lg-6">
                    <div
                      className="section-title"
                      style={{ marginLeft: "-10px" }}
                    >
                      <h4 className="title" style={{ paddingBottom: "15px" }}>
                        <span>
                          Informations du candidat - {candidate?.firstName}{" "}
                          {candidate?.lastName}
                        </span>
                      </h4>
                    </div>
                  </div>
                  <div
                    className="col-lg-6"
                    style={{ textAlign: "right", marginTop: "30px" }}
                  >
                    <a
                      href="assets/#"
                      className="text-primary"
                      data-toggle="modal"
                      title="Modifier le mot de passe"
                      data-target="#changeCandidatePasswordModal"
                      data-original-title="Permit"
                    >
                      <i
                        className="fa fa-key fa-1-5x"
                        onClick={(e) =>
                          openCandidateChangePasswordModal(candidate)
                        }
                      ></i>
                    </a>
                  </div>
                </div>
                <div style={{ marginLeft: "-12px" }}>
                  <div className="form-row">
                    <div className="form-group col-md-6">
                      <label>Prénom *</label>
                      <input
                        value={candidate?.firstName}
                        type="text"
                        className="form-control"
                        id="firstName"
                        placeholder=""
                        onChange={(e) => {
                          let val = e.target?.value;
                          setCandidate((prevState) => {
                            return { ...prevState, firstName: val };
                          });
                        }}
                      />
                      {candidate?.firstName?.length > 50 && (
                        <p style={{ color: "red" }}>
                          le nombre maximum de caractères a été dépassé
                        </p>
                      )}
                    </div>
                    <div className="form-group col-md-6">
                      <label>Nom *</label>
                      <input
                        type="text"
                        value={candidate?.lastName}
                        className="form-control"
                        id="lastName"
                        placeholder=""
                        onChange={(e) => {
                          let val = e.target?.value;
                          setCandidate((prevState) => {
                            return { ...prevState, lastName: val };
                          });
                        }}
                      />
                      {candidate?.lastName?.length > 50 && (
                        <p style={{ color: "red" }}>
                          le nombre maximum de caractères a été dépassé
                        </p>
                      )}
                    </div>
                    <div className="form-group col-md-6">
                      <label>Date de naissance</label>
                      <input
                        value={moment(candidate?.birthDay)?.format(
                          "YYYY-MM-DD"
                        )}
                        type="date"
                        className="form-control"
                        id="birthDay"
                        placeholder=""
                        onChange={(e) => {
                          let val = e.target?.value;
                          let match = isMatch(e.target.value, "yyyy-MM-dd");
                          setCandidate((prevState) => {
                            return { ...prevState, birthDay: val };
                          });
                          if (match && val != "") {
                            setInvalideDate(!match);
                          }
                        }}
                        onBlur={(e) => {
                          let val = isMatch(e.target.value, "yyyy-MM-dd");
                          if (e.target.value != "") {
                            setInvalideDate(!val);
                          }
                          if (!val) {
                            setCandidate((prevState) => {
                              return { ...prevState, birthDay: "" };
                            });
                          }
                        }}
                      />
                      {invalideDate && (
                        <p style={{ color: "red" }}>Format invalide</p>
                      )}
                    </div>
                    <div className="form-group col-md-6">
                      <label>Lieu de naissance</label>
                      <input
                        type="text"
                        value={candidate?.birthPlace}
                        className="form-control"
                        id="birthPlace"
                        placeholder=""
                        onChange={(e) => {
                          let val = e.target?.value;
                          setCandidate((prevState) => {
                            return { ...prevState, birthPlace: val };
                          });
                        }}
                      />
                      {candidate?.birthPlace?.length > 50 && (
                        <p style={{ color: "red" }}>
                          le nombre maximum de caractères a été dépassé
                        </p>
                      )}
                    </div>
                    <div className="form-group col-md-6">
                      <label>
                        Numero de téléphone (
                        {siteService.getCurrentSite().operatorName1})
                      </label>
                      <input
                        type="text"
                        value={candidate?.phoneNumber1}
                        className="form-control"
                        id="phoneNumber1"
                        placeholder=""
                        onChange={(e) => {
                          let val = e.target?.value;
                          setCandidate((prevState) => {
                            return { ...prevState, phoneNumber1: val };
                          });
                        }}
                      />
                      {candidate?.phoneNumber1?.length > 50 && (
                        <p style={{ color: "red" }}>
                          le nombre maximum de caractères a été dépassé
                        </p>
                      )}
                      {candidate?.phoneNumber1 != "" &&
                        !new RegExp(/^[0-9\b]+$/).test(
                          candidate?.phoneNumber1
                        ) && <p style={{ color: "red" }}>Format invalide</p>}
                    </div>
                    <div className="form-group col-md-6">
                      <label>
                        Numero de téléphone (
                        {siteService.getCurrentSite().operatorName2})
                      </label>
                      <input
                        type="text"
                        value={candidate?.phoneNumber2}
                        className="form-control"
                        id="phoneNumber2"
                        placeholder=""
                        onChange={(e) => {
                          let val = e.target?.value;
                          setCandidate((prevState) => {
                            return { ...prevState, phoneNumber2: val };
                          });
                        }}
                      />
                      {candidate?.phoneNumber2?.length > 50 && (
                        <p style={{ color: "red" }}>
                          le nombre maximum de caractères a été dépassé
                        </p>
                      )}
                      {candidate?.phoneNumber2 != "" &&
                        !new RegExp(/^[0-9\b]+$/).test(
                          candidate?.phoneNumber2
                        ) && <p style={{ color: "red" }}>Format invalide</p>}
                    </div>
                    <div className="form-group col-md-12">
                      <label>Adresse (Rue, Quartier, Ville, Pays)</label>
                      <input
                        value={candidate?.address}
                        type="text"
                        className="form-control"
                        id="address"
                        placeholder=""
                        onChange={(e) => {
                          let val = e.target?.value;
                          setCandidate((prevState) => {
                            return { ...prevState, address: val };
                          });
                        }}
                      />
                    </div>
                    <div className="form-group col-md-12">
                      <label>Email *</label>
                      <input
                        value={candidate?.email}
                        type="text"
                        className="form-control"
                        id="email"
                        placeholder=""
                        onChange={(e) => {
                          let val = e.target?.value;
                          let isValide = validator.isEmail(e.target.value);
                          setCandidate((prevState) => {
                            return { ...prevState, email: val };
                          });
                          if (invalideEmail) {
                            setInvalideEmail(!isValide);
                          }
                        }}
                        onBlur={(e) => {
                          let val = validator.isEmail(e.target.value);
                          setInvalideEmail(!val);
                        }}
                      />
                      {candidate?.email?.length > 50 && (
                        <p style={{ color: "red" }}>
                          le nombre maximum de caractères a été dépassé
                        </p>
                      )}
                      {candidate?.email != "" && invalideEmail && (
                        <p style={{ color: "red" }}>Format d'email invalide</p>
                      )}
                    </div>
                    <div className="form-group col-md-12">
                      <label>Catégorie</label>
                      <Select
                        value={categories.filter((opt) =>
                          candidate?.categories?.some((cat) => cat == opt.value)
                        )}
                        options={categories}
                        loadingMessage="En cours de chargement"
                        isMulti
                        onChange={(option) => {
                          const unique = [
                            ...new Set(option.map((item) => item.value)),
                          ];
                          setCandidate((prevState) => {
                            return { ...prevState, categories: unique };
                          });
                        }}
                      />
                    </div>
                    <div className="form-group col-md-12">
                      <div className="custom-control custom-checkbox">
                        <input
                          checked={candidate?.receiveEmailNotification}
                          type="checkbox"
                          className="custom-control-input"
                          id="accepts-01"
                          onChange={(e) => {
                            let val = e.target?.checked;
                            setCandidate((prevState) => {
                              return {
                                ...prevState,
                                receiveEmailNotification: val,
                              };
                            });
                          }}
                        />
                        <label
                          className="custom-control-label"
                          for="accepts-01"
                        >
                          Recevoir les offres d'empoi par email
                        </label>
                      </div>
                      <div className="custom-control custom-checkbox">
                        <input
                          checked={candidate?.receiveSmsNotification}
                          type="checkbox"
                          className="custom-control-input"
                          id="accepts-02"
                          onChange={(e) => {
                            let val = e.target?.checked;
                            setCandidate((prevState) => {
                              return {
                                ...prevState,
                                receiveSmsNotification: val,
                              };
                            });
                          }}
                        />
                        <label
                          className="custom-control-label"
                          for="accepts-02"
                        >
                          Recevoir les offres d'emploi par SMS
                        </label>
                      </div>
                    </div>
                    <div className="col-12 mt-4">
                      <button
                        className="btn btn-primary"
                        onClick={handleSubmit}
                        disabled={isUpdating}
                      >
                        Soumettre &nbsp;{" "}
                        {isUpdating ? (
                          <CircularProgress size={15} />
                        ) : (
                          <span></span>
                        )}
                      </button>
                    </div>
                    {updated && (
                      <div className="col-12 mt-4">
                        <CustomAlert
                          content={
                            "<strong>Félicitations!</strong> Ce compte candidat a été modifié avec succès. "
                          }
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* Start Documents section */}
            <div className="col-lg-12 mt-4 bg-white mt-lg-10">
              <div className="row">
                <div className="col-lg-12">
                  <div className="section-title" style={{ marginLeft: "12px" }}>
                    <h4 className="title" style={{ paddingBottom: "15px" }}>
                      <span>Documents</span>
                    </h4>
                    {candidate.attachments?.length == 0 ? (
                      <p style={{ marginRight: "12px" }}>
                        Veuillez déposer dans cette section vos documents (CV,
                        lettres de présentation, diplômes, attestations, permis
                        de conduire, etc.)
                        <strong>
                          {" "}
                          en cliquant à l'intérieur de la bande blanche
                          ci-dessous
                        </strong>
                      </p>
                    ) : (
                      <p style={{ marginRight: "12px" }}>
                        Veuillez supprimer le fichier existant pour pouvoir
                        ajouter un autre document.
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div
                _lpchecked="2"
                style={{ marginLeft: "12px", marginRight: "20px" }}
              >
                {isUploading ? (
                  <div className="loading-container">
                    <CircularProgress />
                    <div>Chargement des documents en cours...</div>
                  </div>
                ) : (
                  candidate.attachments?.length == 0 && (
                    <div className="form-group mb-5">
                      <DropzoneArea
                        clearOnUnmount={true}
                        dropzoneText={
                          isUploading
                            ? "Chargement en cours..."
                            : "Glisser ou cliquer ici pour déposer vos documents"
                        }
                        showPreviewsInDropzone={false}
                        previewGridProps={{
                          container: { spacing: 1, direction: "row" },
                        }}
                        showAlerts={false}
                        maxFileSize={5000000}
                        filesLimit={10}
                        onChange={(files) => {
                          setSelectedFiles(files);
                        }}
                        onDelete={(file) => {
                          let filteredFiles = [
                            ...selectedFiles.filter(
                              (fi) => fi?.name != file?.name
                            ),
                          ];
                          setSelectedFiles(filteredFiles);
                        }}
                      />
                    </div>
                  )
                )}
                <table className="table manage-candidates-top mb-4">
                  <thead>
                    <tr>
                      <th>Nom</th>
                      <th>Date</th>
                      <th className="action text-right"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <>
                      {candidate?.attachments?.map((file, index) => (
                        <tr key={index}>
                          <td>{file.name}</td>
                          <td>{file.dateCreated}</td>
                          <td style={{ textAlign: "right" }}>
                            <a
                              href={file.url}
                              className="text-primary"
                              target="_blank"
                            >
                              <i className="fas fa-cloud-download-alt"></i>
                            </a>
                            <a
                              href="assets/#"
                              className="text-danger"
                              style={{ marginLeft: "10px" }}
                              data-toggle="modal"
                              title=""
                              data-target="#deleteattachmentModal"
                              data-original-title="Delete"
                            >
                              <i
                                className="far fa-trash-alt"
                                onClick={() => setAttachmentToDelete(file)}
                              ></i>
                            </a>
                          </td>
                        </tr>
                      ))}
                    </>
                  </tbody>
                </table>
              </div>
            </div>
            {/* End Documents section */}
            {/* Start Summary section with title */}
            <div className="col-lg-12 mt-4 bg-white mt-lg-10">
              <div className="row">
                <div className="col-md-7 col-sm-5 d-flex align-items-center">
                  <div className="section-title mb-0">
                    <h3 className="title mb-0">
                      <span>Présentation</span>
                    </h3>
                  </div>
                </div>
                <div
                  className="col-md-5 col-sm-7 mt-3 mt-sm-0 pr-3"
                  style={{ textAlign: "right" }}
                >
                  <button
                    className="btn btn-primary mt-4"
                    onClick={handleSaveButtonClick}
                  >
                    {isSummaryAdding ? (
                      <CircularProgress size={24} />
                    ) : (
                      "Sauvegarder"
                    )}
                  </button>
                </div>
              </div>
              <div className="row">
                <div className="col-xl-12">
                  <div className="mt-4">
                    <div>
                      <div _lpchecked="1">
                        <div className="form-row">
                          <div className="form-group col-md-12">
                            <label>Titre</label>
                            <input
                              value={newSummary.title}
                              type="text"
                              className="form-control"
                              id="title"
                              onChange={(e) => {
                                let val = e.target?.value;
                                setNewSummary((prevState) => {
                                  return { ...prevState, title: val };
                                });
                              }}
                            />
                          </div>
                          <div className="form-group col-md-12">
                            <label>Description</label>
                            <JoditEditor
                              value={newSummary?.description}
                              onChange={handleEditorChange}
                              ref={descriptionHtmlEditor}
                              config={config}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    {error && <p style={{ color: "red" }}>{error}</p>}
                  </div>
                </div>
              </div>
            </div>
            {/* End Summary section with title*/}
            {/* Start educations section */}
            <div className="col-lg-12 mt-4 bg-white mt-lg-10">
              <div className="row">
                <div className="col-md-7 col-sm-5 d-flex align-items-center">
                  <div className="section-title">
                    <h3 className="title">
                      <span>Parcours scolaire</span>
                    </h3>
                  </div>
                </div>
                <div
                  className="col-md-5 col-sm-7  pr-3"
                  style={{ textAlign: "right" }}
                >
                  <button className="btn btn-primary mt-4" onClick={toggleForm}>
                    Ajouter un parcours
                  </button>
                </div>
              </div>
              <div
                _lpchecked="2"
                style={{ marginLeft: "12px", marginRight: "20px" }}
              >
                {showForm == true && (
                  <div className="row">
                    <div className="col-xl-12">
                      <div className="mt-4">
                        <div className="form-row">
                          <div className="form-group col-md-12">
                            <label>Titre </label>
                            <input
                              value={newEducation.title}
                              type="text"
                              className="form-control"
                              id="title"
                              onChange={(e) => {
                                let val = e.target?.value;
                                setNewEducation((prevState) => {
                                  return { ...prevState, title: val };
                                });
                              }}
                            />
                          </div>
                          <div className="form-group col-md-6">
                            <label>Année du debut</label>
                            <Select
                              options={generateYearOptions()}
                              value={generateYearOptions().find(
                                (opt) => opt.value == newEducation.startYear
                              )}
                              onChange={(selectedOption) => {
                                const val = selectedOption.value;
                                setNewEducation((prevState) => ({
                                  ...prevState,
                                  startYear: val,
                                }));
                              }}
                              placeholder=""
                            />
                          </div>
                          <div className="form-group col-md-6">
                            <label>Année de fin</label>
                            <Select
                              options={generateYearOptions()}
                              value={generateYearOptions().find(
                                (opt) => opt.value == newEducation.endYear
                              )}
                              onChange={(selectedOption) => {
                                const val = selectedOption.value;
                                setNewEducation((prevState) => ({
                                  ...prevState,
                                  endYear: val,
                                }));
                              }}
                              placeholder=""
                            />
                          </div>
                          <div className="form-group col-md-6">
                            <label>Diplôme</label>
                            <Select
                              value={degrees.find(
                                (opt) => opt.value === newEducation.degree
                              )}
                              options={degrees}
                              id="degree"
                              onChange={(e) => {
                                let val = e.value;
                                setNewEducation((prevState) => {
                                  return {
                                    ...prevState,
                                    degree: val,
                                  };
                                });
                              }}
                            />
                          </div>
                          <div className="form-group col-md-6">
                            <label>Institut</label>
                            <input
                              value={newEducation.institute}
                              type="text"
                              className="form-control"
                              id="institute"
                              onChange={(e) => {
                                let val = e.target?.value;
                                setNewEducation((prevState) => {
                                  return { ...prevState, institute: val };
                                });
                              }}
                            />
                          </div>
                          <div className="form-group col-md-12">
                            <label>Description</label>
                            <textarea
                              value={newEducation.description}
                              type="text"
                              className="form-control"
                              id="description"
                              placeholder=""
                              onChange={(e) => {
                                let val = e.target?.value;
                                setNewEducation((prevState) => {
                                  return { ...prevState, description: val };
                                });
                              }}
                            ></textarea>
                          </div>
                          <div className="col-12 mt-4">
                            <button
                              className="btn btn-primary"
                              onClick={handleCreateEducationSubmit}
                              disabled={isEducationAdding}
                              style={{ textAlign: "right", float: "right" }}
                            >
                              Ajouter &nbsp;{" "}
                              {isEducationAdding ? (
                                <CircularProgress size={15} />
                              ) : (
                                <span></span>
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div className="row">
                  <div className="col-xl-12">
                    {education.length != 0 && (
                      <div className="timeline-box bg-white p-2">
                        <div className="jobster-candidate-timeline">
                          <div className="jobster-timeline-icon">
                            <i className="fas fa-graduation-cap"></i>
                          </div>

                          {education?.map((education, index) => (
                            <div className="jobster-timeline-item" key={index}>
                              <div className="jobster-timeline-cricle">
                                <i className="far fa-circle"></i>
                              </div>
                              <div className="jobster-timeline-info">
                                <div className="dashboard-timeline-info">
                                  <div className="row">
                                    <div className="col-12">
                                      <div className="row">
                                        <div className="col-12">
                                          <div className="row">
                                            <div className="col-10">
                                              <span className="jobster-timeline-time">
                                                {education.startYear} -{" "}
                                                {education.endYear}
                                              </span>
                                            </div>
                                            <div className="col-2">
                                              <div className="dashboard-timeline-edit">
                                                <ul className="list-unstyled mb-0 d-flex justify-content-end">
                                                  <li className="pr-2">
                                                    <a
                                                      href="javascript:void(0)"
                                                      onClick={() =>
                                                        toggleUpdateForm(
                                                          education
                                                        )
                                                      }
                                                    >
                                                      <i className="fas fa-pencil-alt"></i>
                                                    </a>
                                                  </li>
                                                  <li>
                                                    <a
                                                      href="#"
                                                      className="text-danger"
                                                      data-toggle="modal"
                                                      title=""
                                                      data-target="#deleteEducation"
                                                      data-original-title="Delete"
                                                    >
                                                      <i
                                                        className="far fa-trash-alt text-danger"
                                                        onClick={() =>
                                                          setEducationTodelete(
                                                            education
                                                          )
                                                        }
                                                      ></i>
                                                    </a>
                                                  </li>
                                                </ul>
                                              </div>
                                            </div>
                                          </div>
                                          <h6 className="mb-2">
                                            {education.title}
                                          </h6>
                                          <span>- {education.institute}</span>
                                          <p className="mt-2">
                                            {education.description}
                                          </p>
                                        </div>
                                        {showUpdateForm[education.id] && (
                                          <div className="col-12">
                                            <div className="mt-4">
                                              <div className="form-row">
                                                <div className="form-group col-md-12">
                                                  <label>Titre </label>
                                                  <input
                                                    value={
                                                      updateEducation.title
                                                    }
                                                    type="text"
                                                    className="form-control"
                                                    id="title"
                                                    onChange={(e) => {
                                                      let val = e.target?.value;
                                                      setUpdateEducation(
                                                        (prevState) => {
                                                          return {
                                                            ...prevState,
                                                            title: val,
                                                          };
                                                        }
                                                      );
                                                    }}
                                                  />
                                                </div>
                                                <div className="form-group col-md-6">
                                                  <label>Année de debut</label>
                                                  <Select
                                                    options={generateYearOptions()}
                                                    value={generateYearOptions().find(
                                                      (opt) =>
                                                        opt.value ==
                                                        updateEducation.startYear
                                                    )}
                                                    onChange={(
                                                      selectedOption
                                                    ) => {
                                                      const val =
                                                        selectedOption.value;
                                                      setUpdateEducation(
                                                        (prevState) => ({
                                                          ...prevState,
                                                          startYear: val,
                                                        })
                                                      );
                                                    }}
                                                    placeholder=""
                                                  />
                                                </div>
                                                <div className="form-group col-md-6">
                                                  <label>Année de fin</label>
                                                  <Select
                                                    options={generateYearOptions()}
                                                    value={generateYearOptions().find(
                                                      (opt) =>
                                                        opt.value ==
                                                        updateEducation.endYear
                                                    )}
                                                    onChange={(
                                                      selectedOption
                                                    ) => {
                                                      const val =
                                                        selectedOption.value;
                                                      setUpdateEducation(
                                                        (prevState) => ({
                                                          ...prevState,
                                                          endYear: val,
                                                        })
                                                      );
                                                    }}
                                                    placeholder=""
                                                  />
                                                </div>
                                                <div className="form-group col-md-6">
                                                  <label>Diplôme</label>
                                                  <Select
                                                    value={degrees.find(
                                                      (opt) =>
                                                        opt.value ===
                                                        updateEducation.degree
                                                    )}
                                                    options={degrees}
                                                    id="degree"
                                                    onChange={(e) => {
                                                      let val = e.value;
                                                      setUpdateEducation(
                                                        (prevState) => {
                                                          return {
                                                            ...prevState,
                                                            degree: val,
                                                          };
                                                        }
                                                      );
                                                    }}
                                                  />
                                                </div>
                                                <div className="form-group col-md-6">
                                                  <label>Institut</label>
                                                  <input
                                                    value={
                                                      updateEducation.institute
                                                    }
                                                    type="text"
                                                    className="form-control"
                                                    id="institute"
                                                    onChange={(e) => {
                                                      let val = e.target?.value;
                                                      setUpdateEducation(
                                                        (prevState) => {
                                                          return {
                                                            ...prevState,
                                                            institute: val,
                                                          };
                                                        }
                                                      );
                                                    }}
                                                  />
                                                </div>
                                                <div className="form-group col-md-12">
                                                  <label>Description</label>
                                                  <textarea
                                                    value={
                                                      updateEducation.description
                                                    }
                                                    type="text"
                                                    className="form-control"
                                                    id="description"
                                                    placeholder=""
                                                    onChange={(e) => {
                                                      let val = e.target?.value;
                                                      setUpdateEducation(
                                                        (prevState) => {
                                                          return {
                                                            ...prevState,
                                                            description: val,
                                                          };
                                                        }
                                                      );
                                                    }}
                                                  ></textarea>
                                                </div>
                                                <div className="col-12 mt-4">
                                                  <button
                                                    className="btn btn-primary"
                                                    onClick={
                                                      handleUpdateEducationSubmit
                                                    }
                                                    disabled={
                                                      isEducationUpdating
                                                    }
                                                    style={{
                                                      textAlign: "right",
                                                      float: "right",
                                                    }}
                                                  >
                                                    Mettre à jour &nbsp;{" "}
                                                    {isEducationUpdating ? (
                                                      <CircularProgress
                                                        size={15}
                                                      />
                                                    ) : (
                                                      <span></span>
                                                    )}
                                                  </button>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* End educations section */}
            {/* Start Experiences section */}
            <div className="col-lg-12 mt-4 bg-white mt-lg-10">
              <div className="row">
                <div className="col-md-7 col-sm-5 d-flex align-items-center">
                  <div className="section-title">
                    <h3 className="title">
                      <span>Expérience professionnelle</span>
                    </h3>
                  </div>
                </div>
                <div
                  className="col-md-5 col-sm-7  pr-3"
                  style={{ textAlign: "right" }}
                >
                  <button
                    className="btn btn-primary mt-4"
                    onClick={toggleExperienceForm}
                  >
                    Ajouter une expérience
                  </button>
                </div>
              </div>
              <div
                _lpchecked="2"
                style={{ marginLeft: "12px", marginRight: "20px" }}
              >
                <div className="row">
                  {showExperienceForm == true && (
                    <div className="col-xl-12">
                      <div className="mt-4">
                        <div className="form-row">
                          <div className="form-group col-md-12">
                            <label>Titre </label>
                            <input
                              value={newExperience.title}
                              type="text"
                              className="form-control"
                              id="title"
                              onChange={(e) => {
                                let val = e.target?.value;
                                setNewExperience((prevState) => {
                                  return { ...prevState, title: val };
                                });
                              }}
                            />
                          </div>
                          <div className="form-group col-md-6">
                            <label>Nom de la société </label>
                            <input
                              value={newExperience.companyName}
                              type="text"
                              className="form-control"
                              id="companyName"
                              onChange={(e) => {
                                let val = e.target?.value;
                                setNewExperience((prevState) => {
                                  return { ...prevState, companyName: val };
                                });
                              }}
                            />
                          </div>
                          <div className="form-group col-md-6">
                            <label>Type de travail </label>
                            <Select
                              value={types.find(
                                (opt) => opt.value === newExperience.jobType
                              )}
                              options={types}
                              id="jobType"
                              onChange={(selectedOption) => {
                                let val = selectedOption.value;
                                setNewExperience((prevState) => {
                                  return {
                                    ...prevState,
                                    jobType: val,
                                  };
                                });
                              }}
                            />
                          </div>
                          <div className="form-group col-md-6">
                            <label>De</label>
                            <input
                              value={moment(newExperience.startDate)?.format(
                                "YYYY-MM-DD"
                              )}
                              type="date"
                              className="form-control"
                              id="startDate"
                              placeholder=""
                              onChange={(e) => {
                                let val = e.target?.value;
                                let match = isMatch(
                                  e.target.value,
                                  "yyyy-MM-dd"
                                );
                                setNewExperience((prevState) => {
                                  return { ...prevState, startDate: val };
                                });
                                if (match && val != "") {
                                  setInvalideDate(!match);
                                }
                              }}
                              onBlur={(e) => {
                                let val = isMatch(e.target.value, "yyyy-MM-dd");
                                if (e.target.value != "") {
                                  setInvalideDate(!val);
                                }
                                if (!val) {
                                  setNewExperience((prevState) => {
                                    return { ...prevState, startDate: "" };
                                  });
                                }
                              }}
                            />
                            {invalideDate && (
                              <p style={{ color: "red" }}>Format invalide</p>
                            )}
                          </div>
                          <div className="form-group col-md-6">
                            <label>À</label>
                            <input
                              value={moment(newExperience.endDate)?.format(
                                "YYYY-MM-DD"
                              )}
                              type="date"
                              className="form-control"
                              id="endDate"
                              placeholder=""
                              onChange={(e) => {
                                let val = e.target?.value;
                                let match = isMatch(
                                  e.target.value,
                                  "yyyy-MM-dd"
                                );
                                setNewExperience((prevState) => {
                                  return { ...prevState, endDate: val };
                                });
                                if (match && val != "") {
                                  setInvalideDate(!match);
                                }
                              }}
                              onBlur={(e) => {
                                let val = isMatch(e.target.value, "yyyy-MM-dd");
                                if (e.target.value != "") {
                                  setInvalideDate(!val);
                                }
                                if (!val) {
                                  setNewExperience((prevState) => {
                                    return { ...prevState, endDate: "" };
                                  });
                                }
                              }}
                            />
                            {invalideDate && (
                              <p style={{ color: "red" }}>Format invalide</p>
                            )}
                          </div>

                          <div className="form-group col-md-12">
                            <label>Description</label>
                            <textarea
                              value={newExperience.description}
                              type="text"
                              className="form-control"
                              id="description"
                              placeholder=""
                              onChange={(e) => {
                                let val = e.target?.value;
                                setNewExperience((prevState) => {
                                  return { ...prevState, description: val };
                                });
                              }}
                            ></textarea>
                          </div>
                          <div className="col-12 mt-4">
                            <button
                              className="btn btn-primary"
                              onClick={handleCreateExperienceSubmit}
                              disabled={isExperienceAdding}
                              style={{ textAlign: "right", float: "right" }}
                            >
                              Ajouter &nbsp;{" "}
                              {isExperienceAdding ? (
                                <CircularProgress size={15} />
                              ) : (
                                <span></span>
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                <div className="row">
                  <div className="col-xl-12 mt-2">
                    {workExperience.length != 0 && (
                      <div className="timeline-box bg-white p-2 ">
                        <div className="jobster-candidate-timeline">
                          <div className="jobster-timeline-icon">
                            <i className="fas fa-trophy"></i>
                          </div>

                          {workExperience?.map((experience, index) => (
                            <div className="jobster-timeline-item" key={index}>
                              <div className="jobster-timeline-cricle">
                                <i className="far fa-circle"></i>
                              </div>
                              <div className="jobster-timeline-info">
                                <div className="dashboard-timeline-info">
                                  <div className="row">
                                    <div className="col-12">
                                      <div className="row">
                                        <div className="col-12">
                                          <div className="row">
                                            <div className="col-10">
                                              <span className="jobster-timeline-time">
                                                {moment(
                                                  experience.startDate
                                                ).format("DD-MMMM-YYYY")}{" "}
                                                à{" "}
                                                {moment(
                                                  experience.endDate
                                                ).format("DD-MMMM-YYYY")}
                                              </span>
                                            </div>
                                            <div className="col-2">
                                              <div className="dashboard-timeline-edit">
                                                <ul className="list-unstyled mb-0 d-flex justify-content-end">
                                                  <li className="pr-2">
                                                    <a
                                                      href="javascript:void(0)"
                                                      onClick={() =>
                                                        toggleUpdateExperienceForm(
                                                          experience
                                                        )
                                                      }
                                                    >
                                                      <i className="fas fa-pencil-alt"></i>
                                                    </a>
                                                  </li>
                                                  <li>
                                                    <a
                                                      href="#"
                                                      className="text-danger"
                                                      data-toggle="modal"
                                                      title=""
                                                      data-target="#deleteExperience"
                                                      data-original-title="Delete"
                                                    >
                                                      <i
                                                        className="far fa-trash-alt text-danger"
                                                        onClick={() =>
                                                          setExperienceTodelete(
                                                            experience
                                                          )
                                                        }
                                                      ></i>
                                                    </a>
                                                  </li>
                                                </ul>
                                              </div>
                                            </div>
                                          </div>

                                          <h6 className="mb-2">
                                            {experience.title}
                                          </h6>
                                          <span>
                                            - {experience.companyName}
                                          </span>
                                          <span>- {experience.jobType}</span>
                                          <p className="mt-2">
                                            {experience.description}
                                          </p>
                                        </div>
                                        {showUpdateExperienceForm[
                                          experience.id
                                        ] && (
                                            <div className="col-12">
                                              <div className="mt-4">
                                                <div _lpchecked="1">
                                                  <div className="form-row">
                                                    <div className="form-group col-md-12">
                                                      <label>Titre </label>
                                                      <input
                                                        value={
                                                          updateWorkExperience.title
                                                        }
                                                        type="text"
                                                        className="form-control"
                                                        id="title"
                                                        onChange={(e) => {
                                                          let val =
                                                            e.target?.value;
                                                          setUpdateWorkExperience(
                                                            (prevState) => {
                                                              return {
                                                                ...prevState,
                                                                title: val,
                                                              };
                                                            }
                                                          );
                                                        }}
                                                      />
                                                    </div>
                                                    <div className="form-group col-md-6">
                                                      <label>
                                                        Nom de la société{" "}
                                                      </label>
                                                      <input
                                                        value={
                                                          updateWorkExperience.companyName
                                                        }
                                                        type="text"
                                                        className="form-control"
                                                        id="companyName"
                                                        onChange={(e) => {
                                                          let val =
                                                            e.target?.value;
                                                          setUpdateWorkExperience(
                                                            (prevState) => {
                                                              return {
                                                                ...prevState,
                                                                companyName: val,
                                                              };
                                                            }
                                                          );
                                                        }}
                                                      />
                                                    </div>
                                                    <div className="form-group col-md-6">
                                                      <label>
                                                        Type de travail{" "}
                                                      </label>
                                                      <Select
                                                        value={types.find(
                                                          (opt) =>
                                                            opt.value ===
                                                            updateWorkExperience.jobType
                                                        )}
                                                        options={types}
                                                        id="jobType"
                                                        onChange={(
                                                          selectedOption
                                                        ) => {
                                                          let val =
                                                            selectedOption.value;
                                                          setUpdateWorkExperience(
                                                            (prevState) => {
                                                              return {
                                                                ...prevState,
                                                                jobType: val,
                                                              };
                                                            }
                                                          );
                                                        }}
                                                      />
                                                    </div>
                                                    <div className="form-group col-md-6">
                                                      <label>De</label>
                                                      <input
                                                        value={moment(
                                                          updateWorkExperience.startDate
                                                        )?.format("YYYY-MM-DD")}
                                                        type="date"
                                                        className="form-control"
                                                        id="startDate"
                                                        placeholder=""
                                                        onChange={(e) => {
                                                          let val =
                                                            e.target?.value;
                                                          let match = isMatch(
                                                            e.target.value,
                                                            "yyyy-MM-dd"
                                                          );
                                                          setUpdateWorkExperience(
                                                            (prevState) => {
                                                              return {
                                                                ...prevState,
                                                                startDate: val,
                                                              };
                                                            }
                                                          );
                                                          if (
                                                            match &&
                                                            val != ""
                                                          ) {
                                                            setInvalideDate(
                                                              !match
                                                            );
                                                          }
                                                        }}
                                                        onBlur={(e) => {
                                                          let val = isMatch(
                                                            e.target.value,
                                                            "yyyy-MM-dd"
                                                          );
                                                          if (
                                                            e.target.value != ""
                                                          ) {
                                                            setInvalideDate(!val);
                                                          }
                                                          if (!val) {
                                                            setUpdateWorkExperience(
                                                              (prevState) => {
                                                                return {
                                                                  ...prevState,
                                                                  startDate: "",
                                                                };
                                                              }
                                                            );
                                                          }
                                                        }}
                                                      />
                                                      {invalideDate && (
                                                        <p
                                                          style={{ color: "red" }}
                                                        >
                                                          Format invalide
                                                        </p>
                                                      )}
                                                    </div>
                                                    <div className="form-group col-md-6">
                                                      <label>À</label>
                                                      <input
                                                        value={moment(
                                                          updateWorkExperience.endDate
                                                        )?.format("YYYY-MM-DD")}
                                                        type="date"
                                                        className="form-control"
                                                        id="endDate"
                                                        placeholder=""
                                                        onChange={(e) => {
                                                          let val =
                                                            e.target?.value;
                                                          let match = isMatch(
                                                            e.target.value,
                                                            "yyyy-MM-dd"
                                                          );
                                                          setUpdateWorkExperience(
                                                            (prevState) => {
                                                              return {
                                                                ...prevState,
                                                                endDate: val,
                                                              };
                                                            }
                                                          );
                                                          if (
                                                            match &&
                                                            val != ""
                                                          ) {
                                                            setInvalideDate(
                                                              !match
                                                            );
                                                          }
                                                        }}
                                                        onBlur={(e) => {
                                                          let val = isMatch(
                                                            e.target.value,
                                                            "yyyy-MM-dd"
                                                          );
                                                          if (
                                                            e.target.value != ""
                                                          ) {
                                                            setInvalideDate(!val);
                                                          }
                                                          if (!val) {
                                                            setUpdateWorkExperience(
                                                              (prevState) => {
                                                                return {
                                                                  ...prevState,
                                                                  endDate: "",
                                                                };
                                                              }
                                                            );
                                                          }
                                                        }}
                                                      />
                                                      {invalideDate && (
                                                        <p
                                                          style={{ color: "red" }}
                                                        >
                                                          Format invalide
                                                        </p>
                                                      )}
                                                    </div>

                                                    <div className="form-group col-md-12">
                                                      <label>Description</label>
                                                      <textarea
                                                        value={
                                                          updateWorkExperience.description
                                                        }
                                                        type="text"
                                                        className="form-control"
                                                        id="description"
                                                        placeholder=""
                                                        onChange={(e) => {
                                                          let val =
                                                            e.target?.value;
                                                          setUpdateWorkExperience(
                                                            (prevState) => {
                                                              return {
                                                                ...prevState,
                                                                description: val,
                                                              };
                                                            }
                                                          );
                                                        }}
                                                      ></textarea>
                                                    </div>
                                                    <div className="col-12 mt-4">
                                                      <button
                                                        className="btn btn-primary"
                                                        onClick={
                                                          handleUpdateExperienceSubmit
                                                        }
                                                        disabled={
                                                          isExperienceUpdating
                                                        }
                                                        style={{
                                                          textAlign: "right",
                                                          float: "right",
                                                        }}
                                                      >
                                                        Mettre à jour &nbsp;{" "}
                                                        {isExperienceUpdating ? (
                                                          <CircularProgress
                                                            size={15}
                                                          />
                                                        ) : (
                                                          <span></span>
                                                        )}
                                                      </button>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* End Experiences section */}
            {/* Start Skills section */}
            <div className="col-lg-12 mt-4 bg-white mt-lg-10">
              <div className="row">
                <div className="col-md-7 col-sm-5 d-flex align-items-center">
                  <div className="section-title">
                    <h3 className="title">
                      <span>Compétences Professionnelle</span>
                    </h3>
                  </div>
                </div>
                <div
                  className="col-md-5 col-sm-7  pr-3"
                  style={{ textAlign: "right" }}
                >
                  <button
                    className="btn btn-primary mt-4"
                    onClick={toggleSkillForm}
                  >
                    Ajouter une Compétence
                  </button>
                </div>
              </div>
              <div
                _lpchecked="2"
                style={{ marginLeft: "12px", marginRight: "20px" }}
              >
                <div className="row">
                  {showSkillForm === true && (
                    <div className="col-xl-12">
                      <div className="mt-4">
                        <div className="form-row">
                          <div className="form-group col-md-6">
                            <label>Titre </label>
                            <input
                              value={newSkill.title}
                              type="text"
                              className="form-control"
                              id="title"
                              onChange={(e) => {
                                let val = e.target?.value;
                                setNewSkill((prevState) => {
                                  return { ...prevState, title: val };
                                });
                              }}
                            />
                          </div>
                          <div className="form-group col-md-6">
                            <label>Pourcentage </label>
                            <input
                              value={newSkill.percentage}
                              type="number"
                              className="form-control"
                              id="percentage"
                              min={0}
                              max={100}
                              onChange={(e) => {
                                let val = e.target?.value;
                                val = Math.min(Math.max(val, 0), 100);
                                setNewSkill((prevState) => {
                                  return { ...prevState, percentage: val };
                                });
                              }}
                            />
                          </div>
                          <div className="col-12 mt-4">
                            <button
                              className="btn btn-primary"
                              onClick={handleCreateSkillSubmit}
                              disabled={isSkillAdding}
                              style={{ textAlign: "right", float: "right" }}
                            >
                              Ajouter &nbsp;{" "}
                              {isSkillAdding ? (
                                <CircularProgress size={15} />
                              ) : (
                                <span></span>
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                <div className="row">
                  <div className="col-xl-12 mt-2">
                    {skill.length !== 0 && (
                      <div className="timeline-box bg-white p-2 ">
                        {skill?.map((skill, index) => (
                          <div className="jobster-timeline-item" key={index}>
                            <div className="jobster-timeline-info">
                              <div className="dashboard-timeline-info">
                                <div className="row">
                                  <div className="col-12">
                                    <div className="row">
                                      <div className="col-12">
                                        <div className="row">
                                          <div className="col-10">
                                            <span className="text-dark">
                                              {skill.title}
                                            </span>

                                            <span className="jobster-timeline-time float-right">
                                              {skill.percentage}%
                                            </span>
                                            <div className="progress mt-2">
                                              <div
                                                className="progress-bar"
                                                role="progressbar"
                                                style={{
                                                  width: `${skill.percentage}%`,
                                                }}
                                                aria-valuenow={skill.percentage}
                                                aria-valuemin="0"
                                                aria-valuemax="100"
                                              ></div>
                                            </div>
                                          </div>
                                          <div className="col-2">
                                            <div className="dashboard-timeline-edit">
                                              <ul className="list-unstyled mb-0 d-flex justify-content-end">
                                                <li className="pr-2">
                                                  <a
                                                    href="javascript:void(0)"
                                                    onClick={() =>
                                                      toggleUpdateSkillForm(
                                                        skill
                                                      )
                                                    }
                                                  >
                                                    <i className="fas fa-pencil-alt"></i>
                                                  </a>
                                                </li>
                                                <li>
                                                  <a
                                                    href="#"
                                                    className="text-danger"
                                                    data-toggle="modal"
                                                    title=""
                                                    data-target="#deleteSkill"
                                                    data-original-title="Delete"
                                                  >
                                                    <i
                                                      className="far fa-trash-alt text-danger"
                                                      onClick={() =>
                                                        setSkillTodelete(skill)
                                                      }
                                                    ></i>
                                                  </a>
                                                </li>
                                              </ul>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    {showUpdateSkillForm[skill.id] && (
                                      <div className="col-12">
                                        <div className="mt-4">
                                          <div className="bg-light-3 p-4">
                                            <div _lpchecked="1">
                                              <div className="form-row">
                                                <div className="form-group col-md-6">
                                                  <label>Titre </label>
                                                  <input
                                                    value={updateSkill.title}
                                                    type="text"
                                                    className="form-control"
                                                    id="title"
                                                    onChange={(e) => {
                                                      let val = e.target?.value;
                                                      setUpdateSkill(
                                                        (prevState) => {
                                                          return {
                                                            ...prevState,
                                                            title: val,
                                                          };
                                                        }
                                                      );
                                                    }}
                                                  />
                                                </div>
                                                <div className="form-group col-md-6">
                                                  <label>Pourcentage </label>
                                                  <input
                                                    value={
                                                      updateSkill.percentage
                                                    }
                                                    type="number"
                                                    className="form-control"
                                                    id="percentage"
                                                    min={0}
                                                    max={100}
                                                    onChange={(e) => {
                                                      let val = e.target?.value;
                                                      val = Math.min(
                                                        Math.max(val, 0),
                                                        100
                                                      );
                                                      setUpdateSkill(
                                                        (prevState) => {
                                                          return {
                                                            ...prevState,
                                                            percentage: val,
                                                          };
                                                        }
                                                      );
                                                    }}
                                                  />
                                                </div>

                                                <div className="col-12 mt-4">
                                                  <button
                                                    className="btn btn-primary"
                                                    onClick={
                                                      handleUpdateSkillSubmit
                                                    }
                                                    disabled={isSkillUpdating}
                                                    style={{
                                                      textAlign: "right",
                                                      float: "right",
                                                    }}
                                                  >
                                                    Mettre à jour &nbsp;{" "}
                                                    {isSkillUpdating ? (
                                                      <CircularProgress
                                                        size={15}
                                                      />
                                                    ) : (
                                                      <span></span>
                                                    )}
                                                  </button>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* Start Languages section */}
            <div className="col-lg-12 mt-4 bg-white mt-lg-10">
              <div className="row">
                <div className="col-md-7 col-sm-5 d-flex align-items-center">
                  <div className="section-title">
                    <h3 className="title">
                      <span>Languages</span>
                    </h3>
                  </div>
                </div>
                <div
                  className="col-md-5 col-sm-7  pr-3"
                  style={{ textAlign: "right" }}
                >
                  <button
                    className="btn btn-primary mt-4"
                    onClick={toggleLanguageForm}
                  >
                    Ajouter une Langue
                  </button>
                </div>
              </div>
              <div
                _lpchecked="2"
                style={{ marginLeft: "12px", marginRight: "20px" }}
              >
                <div className="row">
                  {showLanguageForm === true && (
                    <div className="col-xl-12">
                      <div className="mt-4">
                        <div className="form-row">
                          <div className="form-group col-md-4">
                            <label>Nom </label>
                            <input
                              value={newLanguage.name}
                              type="text"
                              className="form-control"
                              id="name"
                              onChange={(e) => {
                                let val = e.target?.value;
                                setNewLanguage((prevState) => {
                                  return { ...prevState, name: val };
                                });
                              }}
                            />
                          </div>
                          <div className="form-group col-md-4">
                            <label>Ecrit </label>
                            <input
                              value={newLanguage.writingLevel}
                              type="number"
                              className="form-control"
                              id="writingLevel"
                              min={0} // Set the minimum value
                              max={10} // Set the maximum value
                              onChange={(e) => {
                                let val = e.target?.value;
                                // Ensure the value is within the specified range
                                val = Math.min(Math.max(val, 0), 10);
                                setNewLanguage((prevState) => {
                                  return { ...prevState, writingLevel: val };
                                });
                              }}
                            />
                          </div>
                          <div className="form-group col-md-4">
                            <label>Parlé </label>
                            <input
                              value={newLanguage.speakingLevel}
                              type="number"
                              className="form-control"
                              id="speakingLevel"
                              min={0} // Set the minimum value
                              max={10} // Set the maximum value
                              onChange={(e) => {
                                let val = e.target?.value;
                                // Ensure the value is within the specified range
                                val = Math.min(Math.max(val, 0), 10);
                                setNewLanguage((prevState) => {
                                  return { ...prevState, speakingLevel: val };
                                });
                              }}
                            />
                          </div>
                          <div className="col-12 mt-4">
                            <button
                              className="btn btn-primary"
                              onClick={handleCreateLanguageSubmit}
                              disabled={isLanguageAdding}
                              style={{ textAlign: "right", float: "right" }}
                            >
                              Ajouter &nbsp;{" "}
                              {isLanguageAdding ? (
                                <CircularProgress size={15} />
                              ) : (
                                <span></span>
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                <div className="row">
                  <div className="col-xl-12 mt-2">
                    {language.length !== 0 && (
                      <div className="timeline-box bg-white p-2 ">
                        {language?.map((language, index) => (
                          <div className="jobster-timeline-item" key={index}>
                            <div className="jobster-timeline-info">
                              <div className="dashboard-timeline-info">
                                <div className="row">
                                  <div className="col-12">
                                    <div className="row">
                                      <div className="col-12">
                                        <div className="row">
                                          <div className="col-10">
                                            <span className="text-dark">
                                              <strong>{language.name}</strong>
                                            </span>
                                            <div className="row">
                                              <div className="col-12">
                                                <div className="row">
                                                  <div className="col-1">
                                                    <div className="mt-2">
                                                      Ecrit:
                                                    </div>
                                                  </div>
                                                  <div className="col-11">
                                                    <div className="">
                                                      <span className="jobster-timeline-time float-right">
                                                        {language.writingLevel}%
                                                      </span>
                                                      <div className="progress mt-0">
                                                        <div
                                                          className="progress-bar"
                                                          role="progressbar"
                                                          style={{
                                                            width: `${(language.writingLevel /
                                                              10) *
                                                              100
                                                              }%`,
                                                          }}
                                                          aria-valuenow={
                                                            language.writingLevel
                                                          }
                                                          aria-valuemin="0"
                                                          aria-valuemax="10"
                                                        ></div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>

                                            <div className="row">
                                              <div className="col-12">
                                                <div className="row">
                                                  <div className="col-1">
                                                    <div className="mt-2">
                                                      Parlé:
                                                    </div>
                                                  </div>
                                                  <div className="col-11">
                                                    <div>
                                                      <span className="jobster-timeline-time float-right">
                                                        {language.speakingLevel}
                                                        %
                                                      </span>
                                                      <div className="progress mt-0">
                                                        <div
                                                          className="progress-bar"
                                                          role="progressbar"
                                                          style={{
                                                            width: `${(language.speakingLevel /
                                                              10) *
                                                              100
                                                              }%`,
                                                          }}
                                                          aria-valuenow={
                                                            language.speakingLevel
                                                          }
                                                          aria-valuemin="0"
                                                          aria-valuemax="10"
                                                        ></div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-2">
                                            <div className="dashboard-timeline-edit">
                                              <ul className="list-unstyled mb-0 d-flex justify-content-end">
                                                <li className="pr-2">
                                                  <a
                                                    href="javascript:void(0)"
                                                    onClick={() =>
                                                      toggleUpdateLanguageForm(
                                                        language
                                                      )
                                                    }
                                                  >
                                                    <i className="fas fa-pencil-alt"></i>
                                                  </a>
                                                </li>
                                                <li>
                                                  <a
                                                    href="#"
                                                    className="text-danger"
                                                    data-toggle="modal"
                                                    title=""
                                                    data-target="#deletelanguage"
                                                    data-original-title="Delete"
                                                  >
                                                    <i
                                                      className="far fa-trash-alt text-danger"
                                                      onClick={() =>
                                                        setLanguageTodelete(
                                                          language
                                                        )
                                                      }
                                                    ></i>
                                                  </a>
                                                </li>
                                              </ul>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <hr />
                                    {showUpdateLanguageForm[language.id] && (
                                      <div className="col-12">
                                        <div className="mt-4">
                                          <div className="bg-light-3 p-4">
                                            <div _lpchecked="1">
                                              <div className="form-row">
                                                <div className="form-group col-md-4">
                                                  <label>Nom </label>
                                                  <input
                                                    value={updateLanguage.name}
                                                    type="text"
                                                    className="form-control"
                                                    id="name"
                                                    onChange={(e) => {
                                                      let val = e.target?.value;
                                                      setUpdateLanguage(
                                                        (prevState) => {
                                                          return {
                                                            ...prevState,
                                                            name: val,
                                                          };
                                                        }
                                                      );
                                                    }}
                                                  />
                                                </div>
                                                <div className="form-group col-md-4">
                                                  <label>Ecrit </label>
                                                  <input
                                                    value={
                                                      updateLanguage.writingLevel
                                                    }
                                                    type="number"
                                                    className="form-control"
                                                    id="writingLevel"
                                                    min={0}
                                                    max={10}
                                                    onChange={(e) => {
                                                      let val = e.target?.value;
                                                      val = Math.min(
                                                        Math.max(val, 0),
                                                        10
                                                      );
                                                      setUpdateLanguage(
                                                        (prevState) => {
                                                          return {
                                                            ...prevState,
                                                            writingLevel: val,
                                                          };
                                                        }
                                                      );
                                                    }}
                                                  />
                                                </div>
                                                <div className="form-group col-md-4">
                                                  <label>Parlé </label>
                                                  <input
                                                    value={
                                                      updateLanguage.speakingLevel
                                                    }
                                                    type="number"
                                                    className="form-control"
                                                    id="speakingLevel"
                                                    min={0} // Set the minimum value
                                                    max={10} // Set the maximum value
                                                    onChange={(e) => {
                                                      let val = e.target?.value;
                                                      // Ensure the value is within the specified range
                                                      val = Math.min(
                                                        Math.max(val, 0),
                                                        10
                                                      );
                                                      setUpdateLanguage(
                                                        (prevState) => {
                                                          return {
                                                            ...prevState,
                                                            speakingLevel: val,
                                                          };
                                                        }
                                                      );
                                                    }}
                                                  />
                                                </div>

                                                <div className="col-12 mt-4">
                                                  <button
                                                    className="btn btn-primary"
                                                    onClick={
                                                      handleUpdateLanguageSubmit
                                                    }
                                                    disabled={
                                                      isLanguageUpdating
                                                    }
                                                    style={{
                                                      textAlign: "right",
                                                      float: "right",
                                                    }}
                                                  >
                                                    Mettre à jour &nbsp;{" "}
                                                    {isLanguageUpdating ? (
                                                      <CircularProgress
                                                        size={15}
                                                      />
                                                    ) : (
                                                      <span></span>
                                                    )}
                                                  </button>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* End Languages section */}
         
           {/* Start Reference section */}
           <div className="col-lg-12 mt-4 bg-white mt-lg-10">
                <div className="row">
                  <div className="col-md-7 col-sm-5 d-flex align-items-center">
                    <div className="section-title">
                      <h3 className="title">
                        <span>Réferences</span>
                      </h3>
                    </div>
                  </div>
                  <div
                    className="col-md-5 col-sm-7  pr-3"
                    style={{ textAlign: "right" }}
                  >
                    <button
                      className="btn btn-primary mt-4"
                      onClick={toggleReferenceForm}
                    >
                      Ajouter une référence
                    </button>
                  </div>
                </div>
                <div className="row">
          {showReferenceForm == true && (
            <div className="col-xl-12">
              <div className="mt-4">
                <div>
                  <div _lpchecked="1">
                    <div className="form-row">
                      <div className="form-group col-md-12">
                        <label>Nom complet *</label>
                        <input
                          value={newReference.fullName}
                          type="text"
                          className="form-control"
                          onChange={(e) => {
                            let val = e.target?.value;
                            setNewReference((prevState) => {
                              return { ...prevState, fullName: val };
                            });
                          }}
                        />
                      </div>
                      <div className="form-group col-md-12">
                        <label>Titre *</label>
                        <input
                          value={newReference.title}
                          type="text"
                          className="form-control"
                          onChange={(e) => {
                            let val = e.target?.value;
                            setNewReference((prevState) => {
                              return {
                                ...prevState,
                                title: val,
                              };
                            });
                          }}
                        />
                      </div>
                      <div className="form-group col-md-12">
                        <label>Email *</label>
                        <input
                          value={newReference.email}
                          type="text"
                          className="form-control"
                          onChange={(e) => {
                            let val = e.target?.value;
                            setNewReference((prevState) => {
                              return {
                                ...prevState,
                                email: val,
                              };
                            });
                          }}
                        />
                      </div>
                      <div className="form-group col-md-6">
                        <label>Numéro de téléphone 1 * </label>
                        <input
                          value={newReference.phoneNumber1}
                          type="text"
                          className="form-control"
                          onChange={(e) => {
                            let val = e.target?.value;
                            setNewReference((prevState) => {
                              return {
                                ...prevState,
                                phoneNumber1: val,
                              };
                            });
                          }}
                        />
                      </div>
                      <div className="form-group col-md-6">
                        <label>Numéro de téléphone 2 </label>
                        <input
                          value={newReference.phoneNumber2}
                          type="text"
                          className="form-control"
                          onChange={(e) => {
                            let val = e.target?.value;
                            setNewReference((prevState) => {
                              return {
                                ...prevState,
                                phoneNumber2: val,
                              };
                            });
                          }}
                        />
                      </div>

                      <div className="col-12 mt-4">
                        <button
                          className="btn btn-primary"
                          onClick={handleCreateReferenceSubmit}
                          disabled={isReferenceAdding}
                          style={{ textAlign: "right", float: "right" }}
                        >
                          Ajouter &nbsp;{" "}
                          {isReferenceAdding ? (
                            <CircularProgress size={15} />
                          ) : (
                            <span></span>
                          )}
                        </button>
                        &nbsp;{" "}
                        &nbsp;{" "}
                        {addReferenceFailed && (
                            <div  className="col-12 mt-5">
                               <CustomAlert content="Erreur lors de cette opération, veuillez réessayer" type="alert-danger" />
                            </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
          )}
        </div>
        <div className="row">
          <div className="col-xl-12 mt-4">
            {candidateReference?.length !== 0 && (
              <div className="timeline-box bg-white p-3 ">
                {candidateReference?.map((reference, index) => (
                  <div className="jobster-timeline-item" key={index}>
                    <div className="jobster-timeline-info">
                      <div className="dashboard-timeline-info">
                        <div className="row">
                          <div className="col-12">
                            <div className="row">
                              <div className="col-12">
                                <div className="row">
                                  <div className="col-10">
                                    <span className="text-dark">
                                      <h6>
                                      <strong>{reference.fullName}</strong>
                                      </h6>
                                    </span>
                                    <div className="row">
                                      <div className="col-12">
                                        <div className="row">
                                          <div className="col-12">
                                            <div className="mt-2">{reference.title}</div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="col-12">
                                        <div className="row">
                                          <div className="col-6">
                                            <div className="mt-2">Tel: {reference.phoneNumber1} / {reference.phoneNumber2}</div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="col-12">
                                        <div className="row">
                                          <div className="col-6">
                                            <div className="mt-2">Email: {reference.email}</div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-2">
                                    <div className="dashboard-timeline-edit">
                                      <ul className="list-unstyled mb-0 d-flex justify-content-end">
                                        <li className="pr-2">
                                          <a
                                            href="javascript:void(0)"
                                            onClick={() =>
                                              toggleUpdateReferenceForm(reference)
                                            }
                                          >
                                            <i className="fas fa-pencil-alt"></i>
                                          </a>
                                        </li>
                                        <li>
                                          <a
                                            href="#"
                                            className="text-danger"
                                            data-toggle="modal"
                                            title=""
                                            data-target="#deleteReference"
                                            data-original-title="Delete"
                                          >
                                            <i
                                              className="far fa-trash-alt text-danger"
                                              onClick={() =>
                                                setReferenceTodelete(reference)
                                              }
                                            ></i>
                                          </a>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <hr />
                            {showUpdateForm[reference.id] && (
                              <div className="col-12">
                              <div className="mt-4">
                                <div className="bg-light-3 p-4">
                                  <div _lpchecked="1">
                                    <div className="form-row">
                                      <div className="form-group col-md-12">
                                        <label>Nom  complet </label>
                                        <input
                                          value={
                                            referenceToUpdate.fullName
                                          }
                                          type="text"
                                          className="form-control"
                                          id="title"
                                          onChange={(e) => {
                                            let val = e.target?.value;
                                            setReferenceToUpdate(
                                              (prevState) => {
                                                return {
                                                  ...prevState,
                                                  fullName: val,
                                                };
                                              }
                                            );
                                          }}
                                        />
                                      </div>
                                      <div className="form-group col-md-12">
                                        <label>
                                          Titre{" "}
                                        </label>
                                        <input
                                          value={
                                            referenceToUpdate.title
                                          }
                                          type="text"
                                          className="form-control"
                                          id="title"
                                          onChange={(e) => {
                                            let val = e.target?.value;
                                            setReferenceToUpdate(
                                              (prevState) => {
                                                return {
                                                  ...prevState,
                                                  title: val,
                                                };
                                              }
                                            );
                                          }}
                                        />
                                      </div>
                                      <div className="form-group col-md-12">
                                        <label>Email </label>
                                        <input
                                          value={
                                              referenceToUpdate.email
                                          }
                                          id="email"
                                          className="form-control"
                                          onChange={(
                                            selectedOption
                                          ) => {
                                            let val =
                                              selectedOption.value;
                                            setReferenceToUpdate(
                                              (prevState) => {
                                                return {
                                                  ...prevState,
                                                  email: val,
                                                };
                                              }
                                            );
                                          }}
                                        />
                                      </div>
                                      <div className="form-group col-md-6">
                                      <label>Numéro de téléphone 1 </label>
                                        <input
                                          value={
                                              referenceToUpdate.phoneNumber1
                                          }
                                          id="phoneNumber1"
                                          className="form-control"
                                          onChange={(
                                            selectedOption
                                          ) => {
                                            let val =
                                              selectedOption.value;
                                            setReferenceToUpdate(
                                              (prevState) => {
                                                return {
                                                  ...prevState,
                                                  phoneNumber1: val,
                                                };
                                              }
                                            );
                                          }}
                                        />
                                      </div>
                                      <div className="form-group col-md-6">
                                      <label>Numéro de téléphone 2 </label>
                                        <input
                                          value={
                                              referenceToUpdate.phoneNumber2
                                          }
                                          id="phoneNumber2"
                                          className="form-control"
                                          onChange={(
                                            selectedOption
                                          ) => {
                                            let val =
                                              selectedOption.value;
                                            setReferenceToUpdate(
                                              (prevState) => {
                                                return {
                                                  ...prevState,
                                                  phoneNumber2: val,
                                                };
                                              }
                                            );
                                          }}
                                        />
                                      </div>
                                      <div className="col-12 mt-4">
                                        <button
                                          className="btn btn-primary"
                                          onClick={
                                            handleUpdateReferenceSubmit
                                          }
                                          disabled={
                                            isReferenceUpdating
                                          }
                                          style={{
                                            textAlign: "right",
                                            float: "right",
                                          }}
                                        >
                                          Mettre à jour &nbsp;{" "}
                                          {isReferenceUpdating ? (
                                            <CircularProgress
                                              size={15}
                                            />
                                          ) : (
                                            <span></span>
                                          )}
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
          </div>
            {/* End Reference section */}

            {/* Start Hobbies section */}
            <div className="col-lg-12 mt-4 bg-white mt-lg-10">
                <div className="row">
                  <div className="col-md-7 col-sm-5 d-flex align-items-center">
                    <div className="section-title">
                      <h3 className="title">
                        <span>Loisirs</span>
                      </h3>
                    </div>
                  </div>
                  <div
                    className="col-md-5 col-sm-7  pr-3"
                    style={{ textAlign: "right" }}
                  >
                    <button
                      className="btn btn-primary mt-4"
                      onClick={toggleHobbyForm}
                    >
                      Ajouter un loisir
                    </button>
                  </div>
                </div>
                <div className="row">
          {showHobbyForm == true && (
            <div className="col-xl-12">
              <div className="mt-4">
                <div>
                  <div _lpchecked="1">
                    <div className="form-row">
                      <div className="form-group col-md-12">
                        <label>Titre</label>
                        <input
                          value={newHobby.title}
                          type="text"
                          className="form-control"
                          onChange={(e) => {
                            let val = e.target?.value;
                            setNewHobby((prevState) => {
                              return { ...prevState, title: val };
                            });
                          }}
                        />
                      </div>
                      <div className="col-12 mt-4">
                        <button
                          className="btn btn-primary"
                          onClick={handleCreateHobbySubmit}
                          disabled={isHobbyAdding}
                          style={{ textAlign: "right", float: "right" }}
                        >
                          Ajouter &nbsp;{" "}
                          {isHobbyAdding ? (
                            <CircularProgress size={15} />
                          ) : (
                            <span></span>
                          )}
                        </button>
                        &nbsp;{" "}
                        &nbsp;{" "}
                        {addHobbyFailed && (
                            <div  className="col-12 mt-5">
                               <CustomAlert content="Erreur lors de cette opération, veuillez réessayer" type="alert-danger" />
                            </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
          )}
        </div>
        <div className="row">
          <div className="col-xl-12 mt-4">
            {candidateHobby?.length !== 0 && (
              <div className="timeline-box bg-white p-3 ">
                {candidateHobby?.map((hobby, index) => (
                  <div className="jobster-timeline-item" key={index}>
                    <div className="jobster-timeline-info">
                      <div className="dashboard-timeline-info">
                        <div className="row">
                          <div className="col-12">
                            <div className="row">
                              <div className="col-12">
                                <div className="row">
                                  <div className="col-10">
                                    <span className="text-dark">
                                     {hobby.title}
                                    </span>
                                  </div>
                                  <div className="col-2">
                                    <div className="dashboard-timeline-edit">
                                      <ul className="list-unstyled mb-0 d-flex justify-content-end">
                                        <li className="pr-2">
                                          <a
                                            href="javascript:void(0)"
                                            onClick={() =>
                                              toggleUpdateHobbyForm(hobby)
                                            }
                                          >
                                            <i className="fas fa-pencil-alt"></i>
                                          </a>
                                        </li>
                                        <li>
                                          <a
                                            href="#"
                                            className="text-danger"
                                            data-toggle="modal"
                                            title=""
                                            data-target="#deleteHobby"
                                            data-original-title="Delete"
                                          >
                                            <i
                                              className="far fa-trash-alt text-danger"
                                              onClick={() =>
                                                setHobbyTodelete(hobby)
                                              }
                                            ></i>
                                          </a>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <hr />
                            {showUpdateForm[hobby.id] && (
                              <div className="col-12">
                              <div className="mt-4">
                                <div className="bg-light-3 p-4">
                                  <div _lpchecked="1">
                                    <div className="form-row">
                                      <div className="form-group col-md-12">
                                        <label>Titre </label>
                                        <input
                                          value={
                                            hobbyToUpdate.title
                                          }
                                          type="text"
                                          className="form-control"
                                          id="title"
                                          onChange={(e) => {
                                            let val = e.target?.value;
                                            setHobbyToUpdate(
                                              (prevState) => {
                                                return {
                                                  ...prevState,
                                                  title: val,
                                                };
                                              }
                                            );
                                          }}
                                        />
                                      </div>
                                      <div className="col-12 mt-4">
                                        <button
                                          className="btn btn-primary"
                                          onClick={
                                            handleUpdateHobbySubmit
                                          }
                                          disabled={
                                            isHobbyUpdating
                                          }
                                          style={{
                                            textAlign: "right",
                                            float: "right",
                                          }}
                                        >
                                          Mettre à jour &nbsp;{" "}
                                          {isHobbyUpdating ? (
                                            <CircularProgress
                                              size={15}
                                            />
                                          ) : (
                                            <span></span>
                                          )}
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
          </div>
            {/* End Hobbies section */}

 {/* Start Delete  modale */}
          <div
          className="modal fade"
          id="deleteHobby"
          tabIndex="-1"
          role="dialog"
          aria-modal="true"
        >
          <div
            className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header p-4">
                <h4 className="mb-0 text-center">Suppression d'un loisir</h4>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <form className="mt-2">
                <div className="modal-body">
                  <div>
                    <div className="form-row">
                      <p>
                        Voulez vous supprimer ce loisir:{" "}
                        {hobbyTodelete?.title}?
                      </p>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    data-dismiss="modal"
                    className="btn btn-primary"
                    ref={closeDeleteHobbyModal}
                  >
                    NON
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleDeleteHobbySubmit}
                    disabled={isHobbyDeletting}
                  >
                    OUI &nbsp;{" "}
                    {isHobbyDeletting ? (
                      <CircularProgress size={15} />
                    ) : (
                      <span></span>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* End Delete  modale */}

          {/* Start Delete file modale */}
          <div
            className="modal fade"
            id="deleteattachmentModal"
            tabIndex="-1"
            role="dialog"
            aria-modal="true"
            data-backdrop="static"
            data-keyboard="false"
          >
            <div
              className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg"
              role="document"
            >
              <div className="modal-content">
                <div className="modal-header p-4">
                  <h4 className="mb-0 text-center">
                    {"Suppression du fichier: " + attachmentToDelete?.fullName}
                  </h4>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <form className="mt-2">
                  <div className="modal-body">
                    <div>
                      <div className="form-row">
                        <p>Êtes-vous sûr de vouloir supprimer ce fichier ?</p>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-primary"
                      data-dismiss="modal"
                      ref={closeFileDeleteModal}
                    >
                      NON
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      disabled={isDeletting}
                      onClick={(e) =>
                        handleDeleteAttachment(attachmentToDelete.id)
                      }
                    >
                      OUI &nbsp;{" "}
                      {isDeletting ? (
                        <CircularProgress size={15} />
                      ) : (
                        <span></span>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          {/* End Delete file modale */}

          {/* Start Delete education modale */}
          <div
            className="modal fade"
            id="deleteEducation"
            tabIndex="-1"
            role="dialog"
            aria-modal="true"
          >
            <div
              className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg"
              role="document"
            >
              <div className="modal-content">
                <div className="modal-header p-4">
                  <h4 className="mb-0 text-center">
                    Suppression d'un parcours scolaire
                  </h4>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <form className="mt-2">
                  <div className="modal-body">
                    <div>
                      <div className="form-row">
                        <p>
                          Voulez vous supprimer ce parcours:{" "}
                          {educationTodelete?.title}?
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      data-dismiss="modal"
                      className="btn btn-primary"
                      ref={closeDeleteEducationModal}
                    >
                      NON
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={handleDeleteEducationSubmit}
                      disabled={isEducationDeletting}
                    >
                      OUI &nbsp;{" "}
                      {isEducationDeletting ? (
                        <CircularProgress size={15} />
                      ) : (
                        <span></span>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          {/* End Delete education  modale */}

          {/* Start Delete experience modale */}
          <div
            className="modal fade"
            id="deleteExperience"
            tabIndex="-1"
            role="dialog"
            aria-modal="true"
          >
            <div
              className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg"
              role="document"
            >
              <div className="modal-content">
                <div className="modal-header p-4">
                  <h4 className="mb-0 text-center">
                    Suppression d'une expérience professionnelle
                  </h4>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <form className="mt-2">
                  <div className="modal-body">
                    <div>
                      <div className="form-row">
                        <p>
                          Voulez vous supprimer cette expérience :{" "}
                          {experienceTodelete?.title}?
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      data-dismiss="modal"
                      className="btn btn-primary"
                      ref={closeDeleteExperienceModal}
                    >
                      NON
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={handleDeleteExperienceSubmit}
                      disabled={isExperienceDeletting}
                    >
                      OUI &nbsp;{" "}
                      {isExperienceDeletting ? (
                        <CircularProgress size={15} />
                      ) : (
                        <span></span>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          {/* End Delete experience  modale */}

          {/*Start change candidate password modal*/}
          <div
            className="modal fade"
            id="changeCandidatePasswordModal"
            tabIndex="-1"
            role="dialog"
            aria-modal="true"
          >
            <div
              className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg"
              role="document"
            >
              <div className="modal-content">
                <div className="modal-header p-4">
                  <h4 className="mb-0 text-center">
                    Modifier le mot de passe de: {selectedCandidate?.firstName}
                  </h4>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <form className="mt-2">
                  {passwordPending == true ? (
                    <div className="loading-container bg-white">
                      <CircularProgress />
                    </div>
                  ) : (
                    <>
                      {published == true ? (
                        <div className="col-12 mt-2 mb-4">
                          <CustomAlert content="Le mot de passe à été modifié avec succès." />
                        </div>
                      ) : (
                        <>
                          <div className="modal-body">
                            <div className="form-row">
                              <label htmlFor="password2">Mot de passe *</label>
                              <input
                                type="password"
                                className="form-control"
                                id="password31"
                                value={loginData?.newPassword}
                                onChange={(e) => {
                                  let val = e.target?.value;
                                  setLoginData((prevState) => {
                                    return { ...prevState, newPassword: val };
                                  });
                                }}
                              />
                            </div>
                          </div>
                          <div className="modal-footer">
                            <button
                              ref={closeCandidateChangePasswordtModal}
                              type="button"
                              className="btn btn-secondary"
                              data-dismiss="modal"
                            >
                              Annuler
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary"
                              onClick={handleChangeCandidatePasswordSubmit}
                            >
                              Sauvergarder &nbsp;{" "}
                              {isPermiting ? (
                                <CircularProgress size={15} />
                              ) : (
                                <span></span>
                              )}
                            </button>
                          </div>
                        </>
                      )}
                    </>
                  )}
                </form>
              </div>
            </div>
          </div>
          {/*End cchange candidate password modal*/}

          {/* Start Delete experience modale */}
          <div
            className="modal fade"
            id="deleteSkill"
            tabIndex="-1"
            role="dialog"
            aria-modal="true"
          >
            <div
              className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg"
              role="document"
            >
              <div className="modal-content">
                <div className="modal-header p-4">
                  <h4 className="mb-0 text-center">
                    Suppression d'une compétence professionnelle
                  </h4>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <form className="mt-2">
                  <div className="modal-body">
                    <div>
                      <div className="form-row">
                        <p>
                          Voulez vous supprimer cette compétence:{" "}
                          {skillTodelete?.title}?
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      data-dismiss="modal"
                      className="btn btn-primary"
                      ref={closeDeleteSkillModal}
                    >
                      NON
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={handleDeleteSkillSubmit}
                      disabled={isSkillDeletting}
                    >
                      OUI &nbsp;{" "}
                      {isSkillDeletting ? (
                        <CircularProgress size={15} />
                      ) : (
                        <span></span>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          {/* End Delete skill  modale */}
          {/* Start Delete  modale */}
          <div
            className="modal fade"
            id="deletelanguage"
            tabIndex="-1"
            role="dialog"
            aria-modal="true"
          >
            <div
              className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg"
              role="document"
            >
              <div className="modal-content">
                <div className="modal-header p-4">
                  <h4 className="mb-0 text-center">Suppression d'une langue</h4>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <form className="mt-2">
                  <div className="modal-body">
                    <div>
                      <div className="form-row">
                        <p>
                          Voulez vous supprimer cette langue:{" "}
                          {languageTodelete?.name}?
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      data-dismiss="modal"
                      className="btn btn-primary"
                      ref={closeDeleteLanguageModal}
                    >
                      NON
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={handleDeleteLanguageSubmit}
                      disabled={isLanguageDeletting}
                    >
                      OUI &nbsp;{" "}
                      {isLanguageDeletting ? (
                        <CircularProgress size={15} />
                      ) : (
                        <span></span>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          {/* End Delete  modale */}

           {/* Start Delete  modale */}
        <div
          className="modal fade"
          id="deleteReference"
          tabIndex="-1"
          role="dialog"
          aria-modal="true"
        >
          <div
            className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header p-4">
                <h4 className="mb-0 text-center">Suppression d'une référence</h4>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <form className="mt-2">
                <div className="modal-body">
                  <div>
                    <div className="form-row">
                      <p>
                        Voulez vous supprimer cette référence:{" "}
                        {referenceTodelete?.fullName}?
                      </p>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    data-dismiss="modal"
                    className="btn btn-primary"
                    ref={closeDeleteReferenceModal}
                  >
                    NON
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleDeleteReferenceSubmit}
                    disabled={isReferenceDeletting}
                  >
                    OUI &nbsp;{" "}
                    {isReferenceDeletting ? (
                      <CircularProgress size={15} />
                    ) : (
                      <span></span>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* End Delete  modale */}
        </>
      )}
    </>
  );
};

CandidateListing.propTypes = {
  storeCandidate: PropTypes.object.isRequired,
  getCandidate: PropTypes.func.isRequired,
  updateCandidate: PropTypes.func.isRequired,
  addCandidateAttachments: PropTypes.func.isRequired,
  deleteAttachment: PropTypes.func.isRequired,
  addCandidateEducation: PropTypes.func.isRequired,
  addCandidateExperience: PropTypes.func.isRequired,
  deleteCandidateEducation: PropTypes.func.isRequired,
  deleteCandidateExperience: PropTypes.func.isRequired,
  CandidateChangePassword: PropTypes.func.isRequired,
  updateCandidateEducation: PropTypes.func.isRequired,
  addCandidateSkills: PropTypes.func.isRequired,
  updateCandidateSkill: PropTypes.func.isRequired,
  deleteCandidateSkill: PropTypes.func.isRequired,
  addCandidateLanguage: PropTypes.func.isRequired,
  updateCandidateLanguage: PropTypes.func.isRequired,
  deleteCandidateLanguage: PropTypes.func.isRequired,
  updateCandidateSummary: PropTypes.func.isRequired,
  addCandidateReference: PropTypes.func.isRequired,
 updateandidateReference: PropTypes.func.isRequired,
  deleteCandidateReference: PropTypes.func.isRequired,
  addCandidateHobby: PropTypes.func.isRequired,
  deleteCandidateHobby: PropTypes.func.isRequired,
  updateCandidateHobby: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  storeCandidate: state.candidate,
  getCandidate: PropTypes.func.isRequired,
  updateCandidate: PropTypes.func.isRequired,
  addCandidateAttachments: PropTypes.func.isRequired,
  deleteAttachment: PropTypes.func.isRequired,
  addCandidateEducation: PropTypes.func.isRequired,
  addCandidateExperience: PropTypes.func.isRequired,
  deleteCandidateEducation: PropTypes.func.isRequired,
  deleteCandidateExperience: PropTypes.func.isRequired,
  CandidateChangePassword: PropTypes.func.isRequired,
  updateCandidateEducation: PropTypes.func.isRequired,
  updateCandidateExperience: PropTypes.func.isRequired,
  addCandidateSkills: PropTypes.func.isRequired,
  updateCandidateSkill: PropTypes.func.isRequired,
  deleteCandidateSkill: PropTypes.func.isRequired,
  addCandidateLanguage: PropTypes.func.isRequired,
  updateCandidateLanguage: PropTypes.func.isRequired,
  deleteCandidateLanguage: PropTypes.func.isRequired,
  updateCandidateSummary: PropTypes.func.isRequired,
  addCandidateReference: PropTypes.func.isRequired,
  updateandidateReference: PropTypes.func.isRequired,
  deleteCandidateReference: PropTypes.func.isRequired,
  addCandidateHobby: PropTypes.func.isRequired,
  deleteCandidateHobby: PropTypes.func.isRequired,
  updateCandidateHobby: PropTypes.func.isRequired,
});

export default connect(mapStateToProps, {
  getCandidate,
  updateCandidate,
  addCandidateAttachments,
  deleteAttachment,
  addCandidateEducation,
  addCandidateExperience,
  addCandidateSkills,
  deleteCandidateEducation,
  deleteCandidateExperience,
  CandidateChangePassword,
  updateCandidateEducation,
  updateCandidateExperience,
  updateCandidateSkill,
  deleteCandidateSkill,
  addCandidateLanguage,
  updateCandidateLanguage,
  deleteCandidateLanguage,
  updateCandidateSummary,
  addCandidateReference,
  updateCandidateReference,
  deleteCandidateReference,
  addCandidateHobby,
  updateCandidateHobby,
  deleteCandidateHobby,
})(CandidateListing);
